import type { Dict } from "./en";

const de: Dict = {
  grid: {
    controls: { group: "Zoom-Steuerung des Gitters", zoomIn: "Vergrößern", zoomOut: "Verkleinern", fit: "Gitter einpassen" },
    hud: { aria: "Gitter-Koordinaten-HUD", instrument: "Instrument", xy: "X · Y", zoom: "Zoom", grid: "Gitter", chain: "Netz" },
    legend: {
      gridZero: { label: "Grid Zero", desc: "Zentraler gesperrter Kern" },
      vipCore: { label: "VIP Core", desc: "Erstklassiger zentraler Ring · verkäuflich" },
      premium: { label: "Premium", desc: "Boulevards & innerer Ring" },
      reserve: { label: "Reserve", desc: "4 gesperrte reservierte Zonen" },
      standard: { label: "Standard", desc: "Allgemeines Territorium" },
    },
    loading: { initializing: "Territorium wird initialisiert" },
    mode: { aria: "Gitter-Interaktionsmodus", select: "Auswählen", selectHint: "Rechteck ziehen", inspect: "Prüfen", inspectHint: "Parcels anklicken", itemAria: "Modus {label} — {hint}" },
    enter3d: { title: "3D betreten", fallbackName: "Territorium" },
    panel: {
      parcelProfileAria: "Parcel-Profil", parcelProfileTitle: "Parcel-Profil", parcel: "Parcel",
      territoryName: "Territoriumsname", owner: "Eigentümer", position: "Position", size: "Größe", slots: "Slots", zone: "Zone",
      claimBlock: "Claim-Block", claimTx: "Claim-Tx", selectTerritory: "Territorium wählen",
      emptySelection: "Zelle hat kein Parcel. Klicke ein eigenes Territorium, um sein Dossier zu sehen.",
      emptyDefault: "Klicke ein Parcel im Gitter, um Eigentum, Koordinaten und On-Chain-Identität zu sehen.",
      contextAria: "Kontextpanel", panelAria: "Panel", closePanel: "Panel schließen", snapshot: "Snapshot",
      titleArtwork: "Werk", titleSelection: "Auswahl", titleContext: "Kontext",
      parcelNum: "Parcel #{id}", selectionSize: "{w} × {h} · {slots} Slots", drawRectHint: "Zeichne ein Rechteck im Gitter",
    },
    context: {
      emptyTitle: "Kein Territorium ausgewählt",
      emptyDesc: "Ziehe ein Rechteck im Gitter, um Slots, Zone, Knappheitsstufe und Preis vorab zu sehen.",
    },
    detail: {
      fetchFailed: "Detailabruf fehlgeschlagen: {error}",
      conflict: "Dateninvarianten-Konflikt in dieser Zelle: {count} Parcels überlappen. Auswahl unterdrückt.",
      cellOutside: "Außerhalb des Gitters ({x}, {y})",
      cellLoadingMap: "Kartendaten werden geladen…",
      cellConfirming: "Zelle ({x}, {y}) wird bestätigt…",
      cellEmpty: "Zelle ({x}, {y}): Kein Parcel in dieser Zelle indexiert (zum Block {block})",
      cellConfirmError: "Aktueller Zellenzustand konnte nicht bestätigt werden.",
      chainMismatch: "Viewer wegen Netz-Diskrepanz nicht verfügbar.",
      indexerNotReady: "Indexer nicht bereit — noch kein Snapshot.",
      clickHint: "Klicke ein Parcel, um Details zu sehen.",
      zoneClassifying: "Klassifizierung…",
      zoneUnavailable: "Nicht verfügbar",
      zoneSaleLocked: "· Verkauf gesperrt",
      zoneMixed: "· Zone gemischt",
    },
    toolbar: {
      territory: "Territorium",
      scrollToZoom: "scrollen zum Zoomen",
      menu: "Menü",
      openNav: "Navigation öffnen",
      hideNav: "Navigation ausblenden",
      revealAreas: "Bereiche zeigen",
      revealAreasAria: "Territoriumszonen anzeigen",
      zonesUnavailable: "Zonenkarte nicht verfügbar — automatischer neuer Versuch",
      zonesRetry: "Erneut versuchen",
      showDragArtwork: "Werk zeigen & ziehen",
      showDragArtworkAria: "Werk zeigen und ziehen",
      showDragArtworkTitle: "Mein Werk im Gitter zeigen und auf ein anderes Parcel ziehen",
      loading: "Laden…",
      myTerritories: "Meine Territorien",
    },
    status: {
      live: "LIVE", cached: "CACHE", chain: "NETZ",
      liveTitle: "Live · synchronisiert",
      cachedTitle: "Letzter bekannter Snapshot wird angezeigt",
      chainTitle: "Netz-Diskrepanz — Viewer-Daten unterdrückt",
    },
    artworkMsg: {
      none: "Du hast noch keine Frozen Artworks.",
      noPlaced: "Keine platzierten Werke zum Verschieben.",
      connectWallet: "Verbinde dein Wallet, um deine Werke zu verschieben.",
    },
    slotCount: {
      slots: "Slots",
      selectedTitle: "{slots} Slots ausgewählt ({w} × {h})",
    },
    bottomSheet: { aria: "Unteres Blatt", dragOpen: "Ziehen zum Anpassen oder Einklappen", handle: "Blattgriff" },
    stats: {
      networkStatus: "Netzwerkstatus", live: "Live", offline: "Offline", syncing: "Synchronisierung", chain: "Netz",
      parcelsClaimed: "Beanspruchte Parcels", onChain: "on-chain", cellsAllocated: "Zugewiesene Zellen",
      finiteWorld: "{pct}% der endlichen Welt", indexerHead: "Indexer-Spitze", finalized: "finalisiert #{block}",
    },
    capacity: {
      territory: "Territorium", resolving: "Territorium wird aufgelöst…", unavailable: "Territoriumskapazität nicht verfügbar",
      area: "Territoriumsfläche", publishability: "Veröffentlichbarkeit", publishable: "Veröffentlichbar",
      notPublishable: "Nicht veröffentlichbar · Minimum {min} u²", gpCapacity: "GP-Kapazität", propertyUnits: "Grundstückseinheiten",
    },
    artworks: {
      title: "Werke auf diesem Land", scanning: "Scannen…",
      empty: "Auf diesem Land sind noch keine Frozen Artworks platziert.", untitled: "Werk ohne Titel", view: "Ansehen →",
    },
    zoomHint: {
      copy: "Zoome hinein, um The Grid zu erkunden. Bei voller Vergrößerung entdeckst du, was Creator auf jedem Parcel veröffentlicht haben.",
      controlDesktop: "Scrollen oder Trackpad zum Zoomen",
      controlMobile: "Zum Zoomen zusammenziehen",
      dontShow: "Nicht mehr anzeigen",
      close: "Schließen",
      enteringParcels: "Du betrittst die Parcels",
    },
  },
  nav: {
    marketplace: "Marketplace",
    feed: "Feed",
    rent: "RENT",
    overview: "Überblick",
    about: "Das Projekt",
    howItWorks: "So funktioniert's",
    explore: "Entdecken",
    creators: "Creators & Marken",
    creatorsShort: "Creators",
    territory: "Territorium",
    profile: "Profil",
    enterGrid: "Zur Grid",
    signIn: "Anmelden",
    navigate: "Navigieren",
    purchaseBadge: "Kauf",
    openMenuAria: "Navigationsmenü öffnen",
    closeMenuAria: "Navigationsmenü schließen",
    primaryAria: "Primär",
    howItWorksHintAria: "Neu hier? So funktioniert THE GRID",
  },
  lang: { ariaLabel: "Sprache", menuLabel: "Sprache wählen" },
  wallet: {
    connect: "Verbinden",
    connecting: "Verbindung…",
    myTerritories: "Meine Territorien",
    sessionDetails: "Sitzungsdetails",
    disconnect: "Trennen",
  },
  auth: {
    title: "Sitzung",
    subtitle: "Wallet-Authentifizierung · SIWE + EIP-1271/6492",
    walletLabel: "Wallet",
    sessionLabel: "Sitzung",
    connectPrompt: "Verbinde eine Wallet über die obere Navigation, um die Anmeldung zu aktivieren.",
    loading: "Lädt…",
    signedInAs: "Angemeldet als {wallet}",
    expires: "läuft ab: {date}",
    signOut: "Abmelden",
    signIn: "Mit Ethereum anmelden",
    chain: "Netzwerk: {name} ({id})",
    status: {
      requestingNonce: "Nonce wird angefordert…",
      requestingSignature: "Signatur von der Wallet wird angefordert…",
      verifying: "Signatur wird geprüft…",
      signedIn: "Angemeldet als {wallet} (Pfad: {path})",
      signedOut: "Abgemeldet",
    },
  },
  home: {
    hero: {
      eyebrow: "// EINE WELT. ENDLICHE MÖGLICHKEITEN.",
      paragraph:
        "Ein einziges, endliches Territorium aus einer Million Zellen. Erkunde, beanspruche und besitze on-chain. Jede Parzelle wird aus demselben Register geprägt, einmalig zugeteilt, für immer.",
      enterGrid: "Zur Grid",
      scrollLine1: "Scrollen zum",
      scrollLine2: "Erkunden",
      scrollAria: "Zum Erkunden scrollen",
    },
    instrument: {
      title: "Instrument",
      labels: { grid: "GITTER", chain: "NETZ", maxZoom: "MAX·Z", auth: "AUTH" },
    },
    callouts: {
      gridZero: { title: "Grid Zero", body: "Kern des Territoriums" },
      lattice: { title: "Datengitter", body: "Zonengrenzen on-chain" },
      cells: { label: "Zellen · Endlich" },
    },
    features: [
      { title: "Endlich per Design", body: "1.000.000 Zellen. Nie mehr." },
      { title: "Auf Base gebaut", body: "On-chain-Territorium · heute auf Base Sepolia." },
      { title: "Öffentlich erkundbar", body: "Lies die Karte ohne Wallet." },
      { title: "Wallet-Eigentum", body: "SIWE · EIP-1271 · EIP-6492 verifiziert." },
    ],
    story: {
      eyebrow: "Unsere Geschichte",
      titleLine1: "EINE NEUE ÄRA",
      titleLine2: "DES",
      titleHighlight: "EIGENTUMS",
      paragraph:
        "Die Grid entstand aus einer einfachen Idee: ein digitales Territorium, das von Grund auf endlich ist und dessen Grenzen im Register leben — nicht auf der Marketingseite. Was du hier besitzt, merkt sich die Kette.",
    },
    roadmap: {
      phaseLabel: "Phase",
      eyebrow: "Zeitleiste",
      phasesLive: "{live} von {total} Phasen aktiv",
      title: "WAS FERTIG IST. WAS KOMMT.",
      paragraph:
        "Eine ehrliche Karte, direkt aus Base gelesen. Grundlagen und Eigentum sind heute aktiv — beanspruche, erstelle, veröffentliche und lass dich jetzt entdecken. Wir sind jetzt im finalen Feinschliff und bei letzten Korrekturen; der nächste große Meilenstein ist das Mainnet, und es erscheint hier erst, wenn das Register, nicht der Text, es real macht.",
      status: { live: "Aktiv", next: "In Arbeit", later: "Geplant" },
      phases: [
        {
          title: "Grundlagen",
          items: [
            "Kanonisches Territorium mit 1.000.000 Zellen auf Base",
            "Live On-chain-Indexer + Reconciler",
            "Wallet-Auth SIWE · EIP-1271 · EIP-6492",
            "Öffentliche Erkundung ohne Wallet",
          ],
        },
        {
          title: "Eigentum & Erstellung",
          items: [
            "Parzellen-Anspruch & USDC-Abwicklung auf Base",
            "Creator-Canvas — Links, Social, Medien, Vorlagen",
            "Optionale 3D-Voxel-Ebene",
            "Veröffentlichen + ehrliche Explore-Entdeckung",
          ],
        },
        {
          title: "Finaler Feinschliff",
          items: [
            "Abnahme-Korrekturen & UX-Feinschliff",
            "Vollständige Mehrsprachigkeit",
            "Härtung & finale QA vor dem Launch",
            "Parcel-RENT-Vorschauseite · Veröffentlichung geplant Q1 2027",
          ],
        },
        {
          title: "Mainnet",
          items: [
            "Mainnet-Deployment auf Base",
            "Angebote, Zweitmarkt & Aktivität",
            "Zertifikate & Creator-Verifizierung",
            "Öffentliche APIs & Erweiterungen",
          ],
        },
      ],
    },
    cta: {
      eyebrow: "Eintreten",
      titlePrefix: "WÄHLE DEIN",
      titleHighlight: "TERRITORIUM",
      paragraph:
        "Die Karte, die du erkundet hast, ist öffentlich. Das Eigentum nicht. Melde dich mit deiner Wallet an, um deine Position zu setzen — das Register merkt sie sich.",
      exploreGrid: "Grid erkunden",
      signIn: "Mit Ethereum anmelden",
    },
    footer: {
      legalAria: "Rechtliches",
      legalToggle: "Rechtliches & Richtlinien",
      walletAuth: "Wallet-authentifiziert",
      territoryData: "Territoriumsdaten · on-chain gelesen",
    },
    slidedots: {
      aria: "Abschnittsnavigation",
      overview: "Überblick",
      story: "Geschichte",
      territory: "Territorium",
      roadmap: "Roadmap",
      enter: "Eintreten",
    },
  },
  about: {
    eyebrow: "Das Manifest",
    titleLine1: "EINE ENDLICHE",
    titleHighlight: "WELT.",
    intro:
      "THE GRID ist ein einziges, endliches digitales Territorium aus einer Million Zellen, einmalig zugeteilt und on-chain besessen. Das ist, woran wir glauben, und was das Produkt wirklich tut — nicht mehr, nichts Erfundenes.",
    principles: [
      {
        title: "Endlich von Grund auf",
        body: "Ein Territorium. Eine Million Zellen. Nie mehr. Knappheit ist hier keine Marketing-Entscheidung — sie steht im Vertrag und kann nicht aufgebläht werden.",
      },
      {
        title: "Eigentum lebt on-chain",
        body: "Eine Parzelle ist ein On-chain-Asset auf Base. Was du hältst, verzeichnet das Register, nicht wir. Die Grenzen deines Territoriums sind überprüfbar, nicht versprochen.",
      },
      {
        title: "Öffentlich als Standard",
        body: "Jeder kann die Karte lesen — keine Wallet, keine Anmeldung. Entdeckung ist offen. Nur Eigentum verlangt, dass du beweist, wer du bist.",
      },
      {
        title: "Eine Leinwand, keine Reklametafel",
        body: "Jedes Territorium ist eine echte Design-Fläche: Text, Links, Social, Medien, Formen und eine optionale 3D-Ebene, alles innerhalb eines ehrlichen Grid-Power-Budgets aus deinem Land.",
      },
      {
        title: "Deine Identität, verifiziert",
        body: "Sign-In With Ethereum mit EOA- und Smart-Contract-Wallets (EIP-1271 / EIP-6492). Wir verwahren nie deine Schlüssel und bewegen nie deine Gelder.",
      },
      {
        title: "Gebaut, um zu bleiben",
        body: "Veröffentlichte Inhalte sind ein dauerhafter Snapshot, getrennt von deinem Arbeitsentwurf. Späteres Bearbeiten bricht nie, was die Öffentlichkeit bereits sieht, bis du erneut veröffentlichst.",
      },
    ],
  },
  how: {
    eyebrow: "Der Weg",
    titleLine1: "VON DER KARTE",
    titleLine2: "ZUM EIGENTUM.",
    intro:
      "Sechs echte Schritte, jeder durch eine bereits gelieferte Funktion gestützt. Das ist der ganze Kreislauf — erkunden, beanspruchen, gestalten, veröffentlichen und entdeckt werden.",
    stepLabel: "SCHRITT {n}",
    toggle: { show: "So funktioniert's", hide: "Ausblenden", aria: "Eine einfache Schritt-für-Schritt-Erklärung anzeigen" },
    steps: [
      {
        title: "Erkunde die Karte",
        body: "Öffne das Territorium und bewege dich über die endliche 1000×1000-Grid. Zoome in jede Parzelle, um zu sehen, wem was gehört — ohne Wallet.",
        detail: {
          intro: "Sich umzusehen ist völlig kostenlos und öffentlich — keine Wallet, kein Konto.",
          points: [
            "Öffne Territorium im oberen Menü, um die ganze Karte zu sehen: ein Raster aus 1.000.000 kleinen Quadraten (Zellen).",
            "Ziehen zum Bewegen, Scrollen zum Zoomen. Zoome in einen Bereich, um zu sehen, welches Land vergeben ist und was die Eigentümer platziert haben.",
            "Nichts verlangt hier eine Anmeldung — die Karte zu lesen ist immer für alle offen.",
          ],
        },
      },
      {
        title: "Beanspruche deine Parzelle",
        body: "Zeichne ein Rechteck auf freiem Land und beanspruche es auf Base. Eigentum wird on-chain geprägt — deine Position verzeichnet das Register, nicht wir.",
        detail: {
          intro: "„Beanspruchen“ bedeutet, Eigentümer eines Rechtecks freier Zellen zu werden. Das Eigentum wird auf Base geschrieben, einer öffentlichen Blockchain.",
          points: [
            "Du brauchst eine Krypto-Wallet — eine kleine, kostenlose Browser-App, die beweist, dass du es bist, und Aktionen bestätigt.",
            "Heute läuft THE GRID auf Base Sepolia, einem Testnetzwerk, also nutzt du Test-USDC — kein echtes Geld.",
            "Zeichne auf der Karte ein Rechteck auf freiem Land und bestätige. Deine Wallet signiert und die Parzelle wird dir geprägt.",
          ],
        },
      },
      {
        title: "Gestalte dein Canvas",
        body: "Mach dein Territorium zu einer echten Seite: Titel, Links, Social, Kontakte, Medien und Formen — oder starte mit einer der sechs Premium-Vorlagen. Alles passt in ein ehrliches Grid-Power-Budget aus deiner Landfläche.",
        detail: {
          intro: "Deine Parzelle ist eine leere Seite, die du steuerst. Fülle sie, oder starte mit einer fertigen Vorlage.",
          points: [
            "Füge Titel, Links, Social-Buttons, Kontakte, Bilder, Video und einfache Formen hinzu.",
            "Lieber ein Startvorsprung? Lade eine der sechs Premium-Vorlagen und passe jedes Detail an.",
            "Jede Parzelle hat ein Grid-Power-Budget nach ihrer Größe — mehr Land lässt dich mehr platzieren. Das hält Seiten ehrlich und schnell.",
          ],
        },
      },
      {
        title: "Füge eine 3D-Ebene hinzu (optional)",
        body: "Gib deinem Territorium Tiefe mit einer Voxel-Szene, die Besucher beim Zoomen betreten können. Völlig optional — ein flaches Canvas ist ebenso ein erstklassiges Ergebnis.",
        detail: {
          intro: "Über der flachen Seite kannst du eine kleine 3D-Szene aus Blöcken (Voxeln) hinzufügen.",
          points: [
            "Besucher betreten die Szene, wenn sie tief in deine Parzelle zoomen.",
            "Es ist völlig optional — du musst nie eine bauen.",
            "Ein flaches Canvas ohne 3D ist ein vollwertiges, erstklassiges Ergebnis.",
          ],
        },
      },
      {
        title: "Veröffentliche",
        body: "Veröffentlichen erstellt einen dauerhaften Snapshot deines gespeicherten Entwurfs. Bearbeite danach privat weiter — die Öffentlichkeit sieht genau das, was du veröffentlicht hast, bis du erneut veröffentlichst.",
        detail: {
          intro: "Veröffentlichen erstellt eine öffentliche Kopie deiner Arbeit — während dein privater Entwurf zum Bearbeiten dein bleibt.",
          points: [
            "Es nimmt einen dauerhaften Snapshot deines gespeicherten Entwurfs und zeigt ihn der Welt.",
            "Du kannst danach privat weiter bearbeiten; Besucher sehen weiter die veröffentlichte Version.",
            "Nichts, was du änderst, wird öffentlich, bis du erneut veröffentlichst.",
          ],
        },
      },
      {
        title: "Werde entdeckt",
        body: "Jede gültige, aktuelle Veröffentlichung erscheint auf Explore, die neueste zuerst — kein Pay-to-Rank, kein falsches Trending. Echtes Eigentum, echte Inhalte, ehrliche Reihenfolge.",
        detail: {
          intro: "Einmal veröffentlicht, ist dein Territorium für alle gelistet — automatisch und fair.",
          points: [
            "Es erscheint auf der Explore-Seite, die neuesten zuerst.",
            "Man zahlt nicht für ein besseres Ranking und es gibt kein falsches „Trending“.",
            "Echtes Eigentum, echte Inhalte, ehrliche Reihenfolge.",
          ],
        },
      },
    ],
    before: {
      eyebrow: "Hier starten",
      title: "Bevor du startest",
      intro: "Zum Umsehen brauchst du fast nichts. Eine Wallet brauchst du erst, wenn du Land besitzen willst.",
      items: [
        { title: "Zum Erkunden: nichts", body: "Die Karte lesen und jede veröffentlichte Seite öffnen ist völlig öffentlich — keine Wallet, keine Anmeldung." },
        { title: "Eine Krypto-Wallet", body: "Zum Beanspruchen und Besitzen brauchst du eine Wallet: eine kleine, kostenlose Browser-App, die beweist, dass du es bist. Wir verwahren nie deine Schlüssel oder Gelder." },
        { title: "Testgeld, kein echtes Geld", body: "Heute läuft THE GRID auf Base Sepolia, einem kostenlosen Testnetzwerk. Du nutzt Test-USDC, um alles sicher auszuprobieren." },
        { title: "Ein paar Minuten", body: "Beanspruchen, Gestalten und Veröffentlichen dauern Minuten — keine Stunden." },
      ],
    },
    journey: {
      eyebrow: "Von Anfang bis Ende",
      title: "Der komplette Weg",
      intro: "Der ganze Kreislauf auf einen Blick. Jeder Schritt führt natürlich zum nächsten.",
      optional: "optional",
      steps: ["Erkunden", "Beanspruchen", "Gestalten", "3D-Ebene", "Veröffentlichen", "Entdeckt werden"],
    },
    draft: {
      eyebrow: "Zwei Versionen",
      title: "Entwurf vs Veröffentlicht",
      intro: "Deine Arbeit lebt immer an zwei Orten. Den Unterschied zu kennen ist der ganze Trick.",
      draftLabel: "Entwurf",
      draftBody: "Deine private Arbeitskopie. Nur du siehst sie. Bearbeite so viel du willst, wann du willst.",
      publishedLabel: "Veröffentlicht",
      publishedBody: "Ein dauerhafter öffentlicher Snapshot. Das sehen Besucher. Er ändert sich nie, bis du erneut veröffentlichst.",
      takeaway: "Deinen Entwurf zu bearbeiten ist immer sicher — die Öffentlichkeit sieht weiter deine letzte veröffentlichte Version.",
    },
    levels: {
      eyebrow: "Drei Zoomstufen",
      title: "Wie THE GRID erlebt wird",
      intro: "Dasselbe Territorium zeigt mehr, je näher du hinschaust.",
      items: [
        { tag: "Herausgezoomt", title: "Die Karte", body: "Sieh das ganze endliche Territorium auf einmal und wo alles ist." },
        { tag: "Hereingezoomt", title: "Eine Seite", body: "Zoome in eine Parzelle und sie wird zu einer echten Seite — das Canvas des Eigentümers mit Text, Links und Medien." },
        { tag: "Tiefer (optional)", title: "In 3D", body: "Zoome weiter in eine Parzelle mit 3D-Ebene und du betrittst ihre Voxel-Szene." },
      ],
    },
    faq: {
      eyebrow: "Einsteigerfragen",
      title: "Einsteiger-FAQ",
      intro: "Neu bei THE GRID oder im Web3? Fang hier an.",
      items: [
        { q: "Brauche ich eine Wallet nur zum Schauen?", a: "Nein. Die Karte erkunden und jede veröffentlichte Seite öffnen ist völlig öffentlich und kostenlos." },
        { q: "Was ist eine „Wallet“?", a: "Eine kleine App — oft eine Browser-Erweiterung — die deine On-chain-Identität hält und dich Aktionen bestätigen lässt. Du behältst die Kontrolle; wir verwahren nie deine Schlüssel oder Gelder." },
        { q: "Ist das echtes Geld?", a: "Heute nicht. THE GRID läuft auf Base Sepolia, einem kostenlosen Testnetzwerk, mit Test-USDC — damit du alles sicher ausprobieren kannst." },
        { q: "Was sind Zellen und Parzellen?", a: "THE GRID ist eine einzige Karte aus 1.000.000 kleinen Quadraten, genannt Zellen. Eine Parzelle ist ein Rechteck aus Zellen, das dir gehört." },
        { q: "Kann ich meine Seite nach dem Veröffentlichen ändern?", a: "Ja. Du behältst einen privaten Entwurf und kannst jederzeit bearbeiten. Die Öffentlichkeit sieht weiter deine letzte veröffentlichte Version, bis du erneut veröffentlichst." },
        { q: "Was ist Grid-Power?", a: "Ein einfaches Budget nach deiner Landgröße, das begrenzt, wie viel du platzieren kannst, und Seiten ehrlich und schnell ladbar hält." },
      ],
    },
  },
  explore: {
    eyebrow: "Entdecken",
    titleLine1: "VERÖFFENTLICHTE",
    titleHighlight: "TERRITORIEN.",
    intro:
      "Echte, aktuell live geschaltete Territorien auf THE GRID — die neuesten zuerst. Kein Pay-to-Rank, kein erfundenes Trending, keine falschen Zähler. Öffne eines, um seine öffentliche Seite zu sehen.",
    error: {
      title: "Öffentliches Verzeichnis konnte nicht geladen werden",
      body: "Der Entdeckungsdienst ist gerade nicht verfügbar. Bitte versuche es gleich erneut.",
      retry: "Erneut versuchen",
    },
    empty: {
      title: "Die Karte wartet",
      body: "Es wurde noch kein Territorium veröffentlicht. Wenn Creators ihr Canvas veröffentlichen, erscheinen sie hier — die neuesten zuerst. Du könntest der Erste sein.",
      claim: "Beanspruche dein Territorium",
      how: "So funktioniert's",
    },
    liveOne: "{count} aktives Territorium",
    liveOther: "{count} aktive Territorien",
    modulesOne: "{count} Modul",
    modulesOther: "{count} Module",
    untitled: "Unbenanntes Territorium",
    view: "Territorium ansehen",
    badgeMedia: "Medien",
  },
  creators: {
    eyebrow: "Creators & Marken",
    titleLine1: "DEIN TERRITORIUM,",
    titleHighlight: "DEINE BÜHNE.",
    intro:
      "Was auch immer du machst, es gibt einen Startpunkt dafür. Sechs Premium-Canvas-Vorlagen verwandeln ein besessenes Territorium in Minuten in eine fertige Seite — dann bearbeitest du jeden Pixel. Vorlagen laden in deinen eigenen Entwurf im Editor; nichts wird veröffentlicht, bis du es entscheidest.",
    sixTemplates: "Sechs Premium-Vorlagen",
    useCases: {
      creator: "Für Macher, die eine persönliche Marke aufbauen — eine klare Identität, Bio und ein einziger Call-to-Action.",
      retail: "Für kleine Shops & Marken — ein Header über einem Produktregal mit klarem Weg zum Kauf.",
      gallery: "Für Künstler — das Werk führt, eine ruhige Aussage folgt.",
      music: "Für Releases & Live-Events — Titel, Datum, Ort und ein direkter Tickets-/Stream-Link.",
      product: "Für Launches — Schlagzeile, Unterzeile, drei Feature-Blöcke und ein CTA.",
      minimal: "Für hochwertigen Minimalismus — Zurückhaltung, Weißraum und eine durchdachte Aktion.",
    },
    noteBefore: "Die Vorlagen leben im Canvas-Editor für ein Territorium, das du besitzt. Öffne ein Territorium, tippe auf ",
    noteBold: "Vorlagen",
    noteAfter: ", wähle einen Startpunkt — er füllt deinen Entwurf, und Speichern / Veröffentlichen bleiben in deiner Hand.",
    howCta: "So funktioniert's",
  },
  rent: {
    eyebrow: "Geplante Funktion",
    titleLine1: "PARCEL",
    titleHighlight: "RENT",
    intro: "Eine geplante Möglichkeit für Territoriumsbesitzer, nur einen Teil ihres Territoriums für zeitlich begrenzte Werbekampagnen an Marken zu vermieten — bei vollem Eigentum an ihrer Parzelle.",
    release: "Geplante Veröffentlichung: Q1 2027",
    status: "Noch nicht verfügbar · Informative Vorschau",
    coexist: {
      eyebrow: "Geteiltes Territorium",
      title: "Ein Territorium. Zwei getrennte Bereiche.",
      body: "Der Besitzer behält seinen eigenen Bereich und seine Identität. Die Kampagne eines Sponsors wäre nur im gemieteten Bereich und nur für begrenzte Zeit sichtbar — beide existieren nebeneinander, ohne sich zu vermischen.",
      ownerLabel: "Besitzer",
      sponsorLabel: "Sponsor",
      ownerLegend: "Besitzerbereich — bleibt beim Besitzer",
      sponsorLegend: "Sponsorbereich — gemietet, zeitlich begrenzt",
      caption: "Illustratives Beispiel — kein echtes Territorium und keine echte Kampagne",
    },
    how: {
      eyebrow: "So soll es funktionieren",
      steps: [
        { title: "Eigentum bleibt", body: "Die Parzelle und ihr NFT wechseln während einer Vermietung nie den Besitzer." },
        { title: "Nur ein Teil wird vermietet", body: "Der Besitzer wählt, welchen Bereich er anbietet; der Rest des Territoriums bleibt unberührt." },
        { title: "Befristete Kampagnen", body: "Ein Sponsor könnte nur im genehmigten Bereich veröffentlichen, und der Zugang endet mit Ablauf der Mietdauer." },
        { title: "Verifiziert & offiziell", body: "Geplante Identitätsprüfungen für RENT-Teilnehmer und Zahlungen über den offiziellen Mietablauf von The Grid." },
      ],
    },
    model: {
      eyebrow: "Vorgeschlagenes Geschäftsmodell",
      title: "Mieteinnahmen für Besitzer. Eine Provision für The Grid.",
      body: "Nach dem vorgeschlagenen Modell kann der Territoriumsbesitzer Mieteinnahmen aus dem vermieteten Bereich erzielen, während The Grid bei jeder offiziellen Miettransaktion eine Provision erhält.",
      cards: [
        { title: "Besitzer", body: "Mögliche Mieteinnahmen aus einem Teil des Territoriums, ohne die Parzelle zu verkaufen." },
        { title: "Marken", body: "Eine befristete Werbepräsenz in ausgewählten Creator-Territorien." },
        { title: "The Grid", body: "Eine Provision auf offizielle Miettransaktionen." },
      ],
      note: "Provisionshöhe, Preise und Mietbedingungen sind noch nicht festgelegt.",
    },
    disclaimer: "Parcel RENT ist eine geplante Funktion und derzeit nicht verfügbar. Heute sind keine Buchungen, Zahlungen oder Vermietungen möglich. Details, Teilnahmebedingungen, Preise und Starttermin können sich ändern; Einnahmen, Traffic oder Ergebnisse sind nicht garantiert.",
  },
  shellCta: {
    title: "Die Karte ist öffentlich. Das Eigentum nicht.",
    body: "Erkunde frei jedes veröffentlichte Territorium. Wenn du bereit bist, eine Position zu beanspruchen, melde dich mit deiner Wallet an — das Register merkt sie sich.",
    explore: "Territorien erkunden",
    enterGrid: "Zur Grid",
  },
  onboarding: {
    profileEntry: { eyebrow: "Geführte Einrichtung" },
    eyebrow: "Geführte Einrichtung",
    title: "Bring dein Territorium an den Start",
    intro: "Ein geführter Weg von null bis zu einem veröffentlichten Territorium. Nichts ist Pflicht — verlasse ihn jederzeit und mach dort weiter, wo du aufgehört hast. Jeder Schritt bringt dich zum echten Werkzeug, und dein Fortschritt wird gespeichert.",
    authRequired: {
      title: "Melde dich an, um die Anleitung zu starten",
      body: "Die geführte Einrichtung ist an deine Wallet gebunden, damit dein Fortschritt gespeichert wird. Eine Wallet zu verbinden reicht nicht — eine signierte Sitzung ist erforderlich.",
      cta: "Mit Ethereum anmelden",
    },
    loading: "Deine Anleitung wird geladen…",
    error: {
      title: "Anleitung konnte nicht geladen werden",
      body: "Der Anleitungsdienst ist gerade nicht verfügbar. Bitte versuche es gleich erneut.",
      retry: "Erneut versuchen",
    },
    progress: {
      label: "Schritt {n} von {total}",
      complete: "{done} von {total} erledigt",
      statusDone: "Erledigt",
      statusNow: "Jetzt",
      statusNext: "Nächster",
      statusLocked: "Später",
    },
    restart: "Anleitung neu starten",
    restartConfirm: "Anleitung neu starten? Dies setzt nur deinen geführten Fortschritt zurück — deine Territorien, Entwürfe und Veröffentlichungen werden nie angetastet.",
    ownershipLost: "Das ausgewählte Territorium gehört dieser Wallet nicht mehr. Wir haben dich zurück zur Territoriumsauswahl gebracht.",
    actions: {
      select: "Auswählen",
    },
    personas: {
      selected: "Ausgewählt",
      creator: {
        label: "Creator",
        desc: "Eine persönliche Marke, ein Portfolio oder eine markante Einzelidentität mit einem klaren Call-to-Action.",
      },
      retail: {
        label: "Business / Retail",
        desc: "Ein Shop, Produkt oder eine Marke — eine klare Kopfzeile über deinem Angebot und ein Weg zum Handeln.",
      },
    },
    steps: {
      persona: {
        title: "Wer bist du?",
        body: "Sag uns, ob du Creator oder Business bist. Wir passen die Startpunkte an — du kannst das jederzeit ändern.",
      },
      territory: {
        title: "Hol dir dein Territorium",
        body: "Besitze einen Teil der Grid und wähle dann, welches Territorium diese Anleitung aufbaut.",
        pick: "Wähle das Territorium zum Aufbauen",
        selectedLabel: "Im Aufbau",
        needLand: "Du besitzt noch kein Land. Beanspruche ein Parcel auf der Grid, um zu starten.",
        getLand: "Land auf der Grid holen",
        nameIt: "Benenne dieses Territorium",
        loading: "Deine Territorien werden aufgelöst…",
        unavailable: "Deine Eigentumsdaten konnten gerade nicht aufgelöst werden. Bitte versuche es gleich erneut.",
      },
      start: {
        title: "Wähle, wie du startest",
        body: "Starte mit einem leeren Canvas oder lade eine der sechs Premium-Vorlagen und mach sie zu deiner. Beides öffnet den echten Editor — nichts wird veröffentlicht, bis du es entscheidest.",
        blank: "Leer starten",
        template: "Vorlage verwenden",
        hint: "Die Vorlagen leben im Editor unter \"Vorlagen\".",
      },
      build: {
        title: "Baue dein Territorium",
        body: "Gestalte dein Canvas: Identität, Medien, Links und Kontakte. Speichere deinen Entwurf, wenn er passt — er bleibt privat, bis du veröffentlichst.",
        open: "Canvas-Editor öffnen",
        draftSaved: "Entwurf gespeichert",
        noDraft: "Noch kein Entwurf gespeichert",
      },
      publish: {
        title: "Veröffentlichen",
        body: "Beim Veröffentlichen wird ein dauerhafter öffentlicher Snapshot deines gespeicherten Entwurfs erstellt. Du kannst danach privat weiter bearbeiten; die Öffentlichkeit sieht deine veröffentlichte Version bis zur erneuten Veröffentlichung.",
        open: "Veröffentlichung öffnen",
        published: "Veröffentlicht",
        notReady: "Speichere zuerst einen Entwurf, dann veröffentliche von deinem Territorium aus.",
      },
      launch: {
        title: "Starten & wachsen",
        body: "Dein Territorium ist live. Teile es — es erscheint automatisch auf Explore, das Neueste zuerst, ohne Pay-to-Rank.",
        viewPublic: "Deine öffentliche Seite ansehen",
        explore: "Auf Explore ansehen",
        copyLink: "Öffentlichen Link kopieren",
        copied: "Link kopiert",
        locked: "Veröffentliche dein Territorium, um diesen Schritt freizuschalten.",
      },
    },
    guide: {
      title: "Geführte Einrichtung",
      heading: "Baue dein Territorium",
      intro: "Füge deine Identität, Visuals und Links hinzu und speichere dann deinen Entwurf.",
      items: {
        identity: "Identität hinzufügen (Titel, Tagline)",
        media: "Ein Visual oder Medium hinzufügen",
        social: "Social- / Kontaktinfos hinzufügen",
        save: "Entwurf speichern",
      },
      back: "Zurück zur Anleitung",
      hide: "Anleitung ausblenden",
    },
    entry: {
      eyebrow: "Neu hier?",
      title: "Lass uns dein erstes Territorium starten",
      body: "Ein kurzer geführter Weg bringt dich vom Beanspruchen von Land zu einer veröffentlichten Seite. Nichts ist Pflicht.",
      start: "Anleitung starten",
      notNow: "Nicht jetzt",
      resume: "Anleitung fortsetzen",
      restart: "Anleitung neu starten",
      completed: "Anleitung abgeschlossen",
    },
    creatorsCta: {
      title: "Neu bei THE GRID? Nimm den geführten Weg.",
      body: "Von einem eigenen Territorium zu einer veröffentlichten Seite in wenigen geführten Schritten — Vorlagen, Aufbau, Veröffentlichung.",
      cta: "Geführte Einrichtung starten",
    },
  },
  marketplace: {
    home: {
      eyebrow: "The Grid · Marketplace",
      title: "Besitze, handle und sammle die Koordinaten einer lebendigen Welt.",
      subtitle: "Jedes Angebot ist backend-autoritativ und fail-closed. Land-Parcels und eingefrorene Werke werden über dieselbe On-Chain-Settlement-Autorität abgewickelt — nichts wird jemals erfunden.",
      browseLand: "Land durchsuchen",
      browseArtworks: "Werke durchsuchen",
      cardLandTitle: "Land",
      cardLandDesc: "Festpreis-Parcels mit zonen-autoritativem Pricing und Cross-Currency-Floors.",
      cardArtworksTitle: "Werke",
      cardArtworksDesc: "Eingefrorene, platzierte Werke, gehandelt mit Creator-Royalties und Live-Auktionen.",
      cardMineTitle: "Mein Markt",
      cardMineDesc: "Deine Angebote, gemachte und erhaltene Gebote sowie Auktionsgebote an einem Ort.",
    },
    nav: {
      search: "Suchen",
      searchAria: "Im Marketplace suchen",
      notifications: "Benachrichtigungen",
      notificationsCountAria: "{count} Benachrichtigungen",
    },
    search: {
      title: "Im Marketplace suchen",
      subtitle: "Parcels · Werke · Adressen",
      placeholder: "Parcel #, Werktitel oder Wallet-Adresse…",
      startTyping: "Tippe, um Angebote und Werke zu suchen.",
      noMatches: "Keine Treffer für „{q}“.",
      land: "Land",
      artwork: "Werk",
      sellerPrefix: "Verkäufer {addr}",
      byPrefix: "von {addr}",
      auctionSuffix: " · Auktion",
    },
    notifications: {
      title: "Benachrichtigungen",
      offersOne: "{n} Angebot zu prüfen",
      offersMany: "{n} Angebote zu prüfen",
      offersDetail: "Käufer haben Angebote auf deine Assets gemacht.",
      outbidOn: "Überboten bei {title}",
      anAuction: "einer Auktion",
      topBid: "Höchstgebot {top} · dein Gebot {yours}",
      allCaughtUp: "Du bist auf dem neuesten Stand.",
      markAll: "Alle als gelesen",
    },
    land: {
      sectionTitle: "Land-Angebote",
      loadErrorTitle: "Angebote konnten nicht geladen werden",
      loadErrorDetail: "Der Marketplace-Index ist gerade nicht erreichbar. Es wurde nichts geändert.",
      emptyNoneTitle: "Noch kein Land inseriert",
      emptyNoneHint: "Wenn Eigentümer Parcels zum Verkauf anbieten, erscheinen sie hier.",
      emptyFilteredTitle: "Keine Angebote entsprechen deinen Filtern",
      emptyFilteredHint: "Erweitere die Preisspanne oder entferne den Zonenfilter.",
      slots: "{n} Slots",
      filters: {
        zone: "Zone",
        price: "Preis (USDC)",
        min: "Min",
        max: "Max",
        minSlots: "Min. Slots",
        any: "Beliebig",
        sort: "Sortieren",
        clear: "Filter zurücksetzen",
        sortRecent: "Neueste",
        sortPriceAsc: "Preis · aufsteigend",
        sortPriceDesc: "Preis · absteigend",
        sortSlotsDesc: "Größte zuerst",
      },
    },
    zones: {
      all: "Alle Zonen",
      standard: "Standard",
      premium: "Premium",
      vip: "VIP",
      reserve: "Reserve",
      gridZero: "Grid Zero",
    },
    artworks: {
      loadErrorTitle: "Werke konnten nicht geladen werden",
      loadErrorDetail: "Der Galerie-Index ist gerade nicht erreichbar.",
      liveAuctions: "Live-Auktionen",
      live: "{n} live",
      gallery: "Galerie",
      works: "{n} Werke",
      emptyTitle: "Noch keine Werke",
      emptyHint: "Eingefrorene, auf der Grid platzierte Werke erscheinen hier für Angebote und Auktionen.",
      auction: "Auktion",
      openToOffers: "Für Angebote offen",
      royalty: "{n}% Royalty",
      by: "von {addr}",
    },
    detail: {
      backToLand: "Zurück zu Land",
      backToArtworks: "Zurück zu Werken",
      listingNotFound: "Angebot nicht gefunden",
      listingNotFoundDetail: "Dieses Angebot wurde möglicherweise verkauft oder zurückgezogen.",
      artworkNotFound: "Werk nicht gefunden",
      artworkNotFoundDetail: "Dieses Werk wurde möglicherweise verschoben oder entfernt.",
      loadingParcel: "Parcel wird geladen…",
      loadingArtwork: "Werk wird geladen…",
      seller: "Verkäufer {addr}",
      creatorOwner: "von {creator} · Eigentümer {owner}",
      slots: "Slots",
      footprint: "Grundfläche",
      floor: "Floor",
      size: "Größe",
      cells: "Zellen",
      royalty: "Royalty",
      status: "Status",
      yourListing: "Dein Angebot",
      buyNow: "Jetzt kaufen",
      unavailable: "Nicht verfügbar",
      makeOffer: "Angebot machen",
      viewOnGrid: "Auf der Grid ansehen",
      sellerNote: "Du bist der Verkäufer — Kauf und Angebote sind für dein eigenes Angebot deaktiviert.",
      ownerNote: "Dir gehört dieses Werk — Angebote und Gebote sind für dich deaktiviert.",
      openOffers: "Offene Angebote",
      noOffersParcel: "Keine offenen Angebote für diesen Parcel.",
      noOffersArtwork: "Keine offenen Angebote für dieses Werk.",
      auctionTag: "Auktion",
      openToOffers: "Für Angebote offen",
      currentBid: "Aktuelles Gebot",
      reserve: "Mindestpreis",
      leadingPrefix: "Führend {addr} · ",
      noBidsYet: "Noch keine Gebote · ",
      minNext: "min. nächstes {amt} {sym}",
      auctionEnded: "Auktion beendet",
      yourAuction: "Deine Auktion",
      placeBid: "Bieten",
      buyTitle: "Parcel #{id} kaufen",
      buySubtitle: "Festpreis-Settlement",
      done: "Fertig",
      cancel: "Abbrechen",
      reserving: "Reservieren…",
      authorizing: "Autorisieren…",
      reserveAuthorize: "Reservieren & autorisieren",
      signInRequired: "Anmeldung erforderlich",
      connectSignIn: "Wallet verbinden & anmelden →",
      settlementUnavailable: "Das Settlement ist vorübergehend nicht verfügbar — es kann gerade nichts abgebucht werden.",
      price: "Preis",
      gridFee: "Grid-Gebühr",
      settlementAuthorized: "Settlement autorisiert",
      settlementAuthorizedBody: "Die Settlement-Autorität hat dein Permit signiert. Schließe den Kauf aus deinem Wallet ab, um on-chain zu finalisieren.",
      authorityFloor: "Autorität {addr} · Floor {amt} {sym}",
      completePurchase: "Complete purchase",
      checkingAllowance: "Checking allowance…",
      confirmInWallet: "Confirm in your wallet…",
      approvingUsdc: "Approving USDC…",
      settlingOnchain: "Finalizing on-chain…",
      purchaseComplete: "Purchase complete",
      purchaseCompleteBody: "The LAND is now yours. Ownership and listings will refresh shortly.",
      buyFailed: "Purchase failed",
      approveRejected: "USDC approval was rejected in your wallet.",
      approveReverted: "The USDC approval transaction reverted on-chain.",
      fillRejected: "The purchase was rejected in your wallet.",
      fillReverted: "The purchase transaction reverted on-chain.",
      wrongBuyerWallet: "Connect the buyer wallet {addr} to complete the purchase.",
      makeOfferTitle: "Ein Angebot machen",
      makeOfferSubtitle: "Verbindliches Angebot · Ablauf in Market-Time",
      submitOffer: "Angebot senden",
      submitting: "Wird gesendet…",
      amount: "Betrag",
      expiresIn: "Läuft ab in",
      dur1h: "1 Stunde",
      dur24h: "24 Stunden",
      dur3d: "3 Tage",
      dur7d: "7 Tage",
      placeBidTitle: "Ein Gebot abgeben",
      auctionFallback: "Auktion",
      signing: "Signieren…",
      yourBid: "Dein Gebot ({sym})",
      minNextBid: "Mindest-Folgegebot: {amt} {sym}",
      bidPermitSigned: "Gebots-Permit signiert",
      bidPermitBody: "Die Settlement-Autorität hat dein Gebots-Permit signiert. Reiche es aus deinem Wallet ein, um das Gebot on-chain zu erfassen.",
      antiSnipe: " Dein Gebot fällt in das Anti-Snipe-Fenster und verlängert die Auktion.",
      authorityMin: "Autorität {addr} · min. akzeptiert {amt} {sym}",
    },
    provenance: {
      title: "Verlauf / Herkunft",
      empty: "Noch kein Eigentumsverlauf für diese Parzelle.",
      resale: "Weiterverkauf",
      primaryPurchase: "Erstkauf",
      privateSale: "Privatverkauf",
      transfer: "Übertragung",
      from: "Von",
      to: "An",
      price: "Preis",
      fee: "Gebühr",
      net: "Netto",
      viewTx: "Tx ansehen →",
      currentNameLabel: "Aktueller Name",
    },
    owner: {
      cancelPrivateSale: "Stornieren",
      cancelBlocked: "Nicht stornierbar",
      cancelUnsupportedNote: "Die On-Chain-Stornierung des Privatverkaufs wird vom bereitgestellten Vertrag nicht unterstützt. Stornierungsanfragen schlagen sicher fehl und ändern niemals den Datensatz.",
      cancelPsTitle: "Privatverkauf stornieren",
      cancelPsBadge: "Owner-Aktion",
      cancelPsWarning: "Dies fordert die On-Chain-Stornierung des Privatverkaufs an. Sie wird erst nach Bestätigung der Transaktion on-chain wirksam.",
      cancelPsSuccess: "Privatverkauf on-chain storniert.",
      cancelPsConfirm: "Stornierung anfordern",
      cancelPsClose: "Schließen",
      cancelPsUnsupported: "Der bereitgestellte Vertrag unterstützt keine On-Chain-Stornierung des Privatverkaufs. Es wurde kein Datensatz geändert.",
      psStatusActive: "Aktiv",
      psStatusCompleted: "Abgeschlossen",
      psStatusExpired: "Abgelaufen",
      psStatusCancelled: "Storniert",
      verifyingAccess: "Owner-Zugriff wird geprüft…",
      accessDeniedTitle: "Owner-Zugriff erforderlich",
      accessDeniedHint: "Diese Konsole ist auf server-freigegebene Owner-Wallets beschränkt. Melde dich mit einem Admin-Wallet an.",
      loadErrorTitle: "Owner Console konnte nicht geladen werden",
      loading: "Owner Console wird geladen…",
      integrityTitle: "Supply-Integrität",
      noFreeGrant: "Kein kostenloser Grant ✓",
      grantAnomaly: "Grant-Anomalie ✕",
      supplyActiveListings: "Aktive Angebote",
      supplySoldListings: "Verkaufte Angebote",
      supplyOpenOffers: "Offene Angebote",
      supplyOpenAuctions: "Offene Auktionen",
      supplyPendingSettlements: "Ausstehende Settlements",
      supplyPaidAcquisitions: "Bezahlte Erwerbe",
      zeroPriceGrants: "Null-Preis-Grants",
      actionsTitle: "Owner-Aktionen",
      gridZeroManual: "Grid Zero manuell",
      releaseLabel: "Release",
      releaseDesc: "Geeignetes Inventar verfügbar machen. Cell-authoritative: freigegeben, nicht effektiv reserviert, nicht belegt.",
      relockLabel: "Relock",
      relockDesc: "Verfügbares Inventar erneut sperren. Sperrt niemals verkaufte, belegte oder anderweitig ungeeignete Zellen.",
      privateSaleLabel: "Privatverkauf",
      privateSaleDesc: "Einen käufergebundenen Verkauf erstellen. Der Tier-Preis ist offiziell; Grid Zero ist manuell. Der Preis muss > 0 sein.",
      failClosed: "Fail-closed",
      unavailable: "Nicht verfügbar",
      privateSalesTitle: "Privatverkäufe",
      noPrivateSalesTitle: "Keine Privatverkäufe projiziert",
      noPrivateSalesHint: "Privatverkäufe erscheinen hier, sobald sie on-chain erstellt wurden — stornierbar bis zum Pending.",
      buyer: "Käufer {addr}",
      perSlot: "/ Slot",
      executed: "Ausgeführt",
      pending: "Ausstehend",
      supplyCheckTitle: "Supply-Prüfung",
      walletPlaceholder: "0x Wallet-Adresse",
      checking: "Wird geprüft…",
      auditWallet: "Wallet auditieren",
      supplyCheckFailed: "Supply-Prüfung fehlgeschlagen",
      owned: "Im Besitz",
      paidOrigin: "Bezahlter Ursprung",
      integrity: "Integrität",
      consistent: "Konsistent",
      anomalies: "Anomalien",
      confirmationSuffix: "{tier} Bestätigung",
      tierNormal: "normale",
      tierStrong: "starke",
      tierMaximum: "maximale",
      failClosedBanner: "Fail-closed: {reason}. Diese Aktion kann nicht ausgeführt werden — es wird nichts abgebucht oder erfunden.",
      typeToProceedPre: "Tippe ",
      typeToProceedPost: " zum Fortfahren",
      ack: "Ich verstehe, dass dies eine cell-authoritative Owner-Aktion ist, und bestätige Ziel und Menge.",
      confirmAction: "{action} bestätigen",
      submitting: "Wird gesendet…",
      cancel: "Abbrechen",
      zoneLabel: "Zone",
      slotsLabel: "Slots",
      buyerLabel: "Käufer-Wallet",
      priceLabel: "Stückpreis (USDC)",
      priceHintGridZero: "Grid Zero erfordert einen manuellen Stückpreis > 0.",
      priceHintTier: "Der Tier-Preis ist offiziell und wird automatisch angewendet.",
      actionSuccess: "Owner-Aktion ausgeführt",
      actionSuccessBody: "{action}: {count} Zellen in {zone} — im unveränderlichen Owner-Audit erfasst. Kein kostenloser Grant, kein On-Chain-Write.",
      demoScope: "Preview Demo — isoliertes Substrate, kein On-Chain-Write",
    },
    common: {
      parcelNumber: "Parcel #{id}",
      partialTag: "TEILWEISE",
      close: "Schließen",
      retry: "Erneut versuchen",
    },
    confirm: {
      normal: "Bitte bestätige diese cell-authoritative Owner-Aktion.",
      strong: "Dies betrifft {slots} Slots (über {threshold}). Gib die exakte Slot-Anzahl erneut ein, um fortzufahren.",
      maximum: "GRID ZERO ist das sensibelste Inventar auf THE GRID. Die maximale Bestätigung ist unabhängig von der Menge erforderlich.",
    },
    statePill: {
      active: "aktiv",
      sale_pending: "Verkauf ausstehend",
      confirming: "wird bestätigt",
      sold: "verkauft",
      expired: "abgelaufen",
      cancelled: "storniert",
      reconciliation_required: "Abgleich erforderlich",
      open: "offen",
    },
    errors: {
      unauthenticatedTitle: "Anmeldung erforderlich",
      unauthenticatedHint: "Verbinde dein Wallet und melde dich an, um diese Aktion zu autorisieren.",
      disabledTitle: "Markt pausiert",
      disabledHint: "Das Settlement ist vorübergehend nicht verfügbar. Es wurde nichts abgebucht oder geändert — versuche es nach der Wiederaufnahme erneut.",
      cellLockedTitle: "Von einem anderen Käufer reserviert",
      cellLockedHint: "Eine oder mehrere Zellen dieses Parcels werden gerade durch den ausstehenden Kauf eines anderen Käufers gehalten. Versuche es in ein paar Minuten erneut.",
      notActiveTitle: "Nicht mehr verfügbar",
      notActiveHint: "Dieses Angebot ist nicht mehr aktiv — es wurde möglicherweise gerade verkauft oder zurückgezogen. Aktualisiere für den neuesten Stand.",
      expiredTitle: "Angebot abgelaufen",
      expiredHint: "Dieses Angebot ist abgelaufen und kann nicht mehr gekauft werden. Der Eigentümer kann es neu inserieren.",
      selfTitle: "Das ist dein Angebot",
      selfHint: "Du kannst nicht auf ein Asset bieten oder es kaufen, das du bereits verkaufst.",
      belowFloorTitle: "Unter dem Floor-Preis",
      belowFloorHint: "Der Preis hat sich geändert und liegt jetzt unter dem Floor des Verkäufers. Prüfe und versuche es erneut.",
      settlementTitle: "Settlement läuft",
      settlementHint: "Für dieses Asset läuft bereits ein Settlement. Warte auf dessen Abschluss, bevor du es erneut versuchst.",
      reconciliationTitle: "Abgleich erforderlich",
      reconciliationHint: "Dieses Asset muss vor dem Handel mit der Chain abgeglichen werden. Es wurde keine Aktion ausgeführt.",
      spatialTitle: "Platzierungskonflikt",
      spatialHint: "Dieses Werk befindet sich gerade nicht in einer abwickelbaren Platzierung — es wurde möglicherweise verschoben oder überlappt eine andere Platzierung.",
      bidLowTitle: "Gebot zu niedrig",
      bidLowHint: "Dein Gebot liegt unter dem nächsten Mindestgebot. Erhöhe es und versuche es erneut.",
      permitReusedTitle: "Permit bereits verwendet",
      permitReusedHint: "Dieses Gebots-Permit wurde bereits verbraucht. Gib ein neues Gebot ab.",
      auctionClosedTitle: "Auktion geschlossen",
      auctionClosedHint: "Diese Auktion nimmt keine Gebote mehr an.",
      auctionNotStartedTitle: "Auktion nicht gestartet",
      auctionNotStartedHint: "Diese Auktion ist noch nicht für Gebote geöffnet.",
      sellerBidTitle: "Verkäufer können nicht bieten",
      sellerBidHint: "Du kannst nicht auf deine eigene Auktion bieten.",
      permitRefusedTitle: "Autorisierung abgelehnt",
      permitRefusedHint: "Die Settlement-Autorität hat die Signatur verweigert. Es wurde keine Aktion ausgeführt.",
      noBasisTitle: "Ursprung nicht erfasst",
      noBasisHint: "Dieses Asset hat noch keinen erfassten BEZAHLTEN Erwerbsursprung und kann daher nicht abgewickelt werden. Es wurde keine Aktion ausgeführt.",
      zeroAmountTitle: "Betrag erforderlich",
      zeroAmountHint: "Gib einen Betrag größer als null ein.",
      genericTitle: "Etwas ist schiefgelaufen",
      genericHint: "Die Aktion konnte nicht abgeschlossen werden. Es wurde nichts geändert.",
    },
    tabs: {
      overview: "Übersicht",
      land: "Land",
      artworks: "Werke",
      mine: "Mein Markt",
      owner: "Owner Console",
      ownerAria: "Owner Console — nur Admin",
    },
    states: {
      loading: "Wird geladen…",
      retry: "Erneut versuchen",
      active: "aktiv",
    },
    paused: {
      title: "Markt pausiert",
      body: "Das Settlement ist vorübergehend nicht verfügbar. Das Durchsuchen bleibt offen; es kann nichts abgebucht werden.",
    },
    mine: {
      signInTitle: "Melde dich an, um deinen Markt zu sehen",
      signInHint: "Verbinde dein Wallet und melde dich an, um deine Angebote, Gebote und Auktionsgebote zu sehen.",
      connectSignIn: "Verbinden & anmelden →",
      loadErrorTitle: "Dein Markt konnte nicht geladen werden",
      loadingYours: "Dein Markt wird geladen…",
      listings: "Meine Angebote",
      listLand: "Land verkaufen",
      noListings: "Keine aktiven Angebote",
      noListingsHint: "Inseriere einen Parcel von seiner Detailseite — oder über Land verkaufen —, um ihn zu verkaufen.",
      offersReceived: "Erhaltene Angebote",
      offersMade: "Gemachte Angebote",
      bids: "Meine Gebote",
      noBids: "Keine aktiven Gebote",
      noBidsHint: "Biete auf eine Live-Auktion, um sie hier zu sehen.",
      cancel: "Abbrechen",
      withdraw: "Zurückziehen",
      noOpenOffers: "Keine offenen Angebote",
      noOffersReceived: "Keine Angebote erhalten",
      offerMadeHint: "Mache ein Angebot von jedem Angebot oder Werk aus.",
      offerReceivedHint: "Angebote auf deine Assets erscheinen hier.",
      accept: "Annehmen",
      decline: "Ablehnen",
      accepting: "Wird angenommen…",
      acceptUnsupported: "Dieser Angebotstyp kann hier noch nicht angenommen werden.",
      pendingPurchases: "Ausstehende Käufe",
      noPendingPurchases: "Keine ausstehenden Käufe",
      pendingPurchasesHint: "Vom Verkäufer angenommene Angebote erscheinen hier, um den Kauf abzuschließen.",
      completePurchase: "Kauf abschließen",
      auction: "Auktion",
      leading: "Führend",
      outbid: "Überboten",
      bidPrefix: "Gebot",
      artworkLabel: "Kunstwerk",
      sales: "Verkäufe",
      purchases: "Käufe",
      noSales: "Noch keine Verkäufe",
      noSalesHint: "Parzellen, die du auf dem Sekundärmarkt verkaufst, erscheinen hier.",
      noPurchases: "Noch keine Käufe",
      noPurchasesHint: "Parzellen, die du auf dem Sekundärmarkt kaufst, erscheinen hier.",
      soldTo: "Verkauft an",
      boughtFrom: "Gekauft von",
      feeShort: "Gebühr",
      netShort: "Netto",
      soldStatus: "Verkauft",
      viewTx: "Tx ansehen →",
    },
    sell: {
      slotsSelected: "Ausgewählte Felder",
      partialBadge: "Teilbereich",
      realSelectTitle: "Wählen Sie den zu verkaufenden Bereich",
      realSelectHint: "Klicken oder ziehen Sie, um Zellen auszuwählen. Wählen Sie die gesamte Parzelle zum Listen oder einen zusammenhängenden Bereich für einen Teilverkauf.",
      selectWhole: "Ganze Parzelle auswählen",
      wholeSelectedNote: "Ganze Parzelle ausgewählt — die gesamte Parzelle wird gelistet.",
      wholeIneligibleTitle: "Verkauf der ganzen Parzelle nicht verfügbar",
      wholeIneligibleBody: "Ein Teil dieser Parzelle ist nicht zulässig — eine aktive Marktplatz-Sperre oder kanonischer Inhalt (eine platzierte Grafik) belegt eine oder mehrere Zellen. Das Listing der ganzen Parzelle ist blockiert, bis diese Zellen frei sind. Es wurde kein Angebot erstellt.",
      partialDisabledTitle: "Teilverkauf nicht verfügbar",
      partialVaultRequired: "Ein Teilbereichsverkauf erfordert ein On-Chain-SubdivisionVault-Child-Token für diese Parzelle, das noch nicht existiert. Erstellen Sie die Unterteilung on-chain, bevor Sie diesen Bereich listen. Es wurde kein Angebot erstellt.",
      subdivisionTooComplex: "Die gewählte Form überschreitet das On-Chain-Unterteilungslimit ({total}/{max} Rechtecke) — passe deine Auswahl an. Keine Transaktion gesendet.",
      subAlreadySubdivided: "Diese Parzelle ist bereits on-chain unterteilt. Erneute Unterteilung wird noch nicht unterstützt.",
      subDepositFailed: "Einzahlung der Parzelle in den Vault fehlgeschlagen.",
      subSplitFailed: "Der On-Chain-Unterteilungs-Split ist fehlgeschlagen.",
      subGeometryMismatch: "Die On-Chain-Child-Geometrie stimmt nicht mit deiner Auswahl überein.",
      sub_plan: "Unterteilung wird berechnet…",
      sub_approve: "Vault wird freigegeben…",
      sub_approveCollection: "Marktplatz wird freigegeben…",
      nftApprovalFailed: "Die Übertragungsfreigabe für den Marktplatz ist fehlgeschlagen. Es wurde kein Angebot erstellt.",
      sub_deposit: "Parzelle wird eingezahlt…",
      sub_split: "On-Chain-Unterteilung…",
      sub_reconcile: "Abgleich…",
      sub_sign: "Signieren & listen…",
      wholeTitle: "List the whole parcel",
      wholeSubtitle: "Parcel #{id} · whole parcel",
      wholeBadge: "Whole parcel",
      wholeIntro: "You are authorizing a REAL secondary-market listing of the ENTIRE parcel on Base Sepolia. Your wallet signs an EIP-712 order; nothing is written on-chain until a buyer fills it.",
      wholeConnectRequired: "Connect the owner wallet to authorize this listing.",
      wholeOwnerMismatch: "The connected wallet is not the on-chain owner of this parcel.",
      wholeNotConfigured: "The marketplace contract is not configured for real listings.",
      signAndList: "Sign & list",
      signing: "Awaiting wallet signature…",
      reviewToken: "Token ID",
      reviewCollection: "Collection",
      realCreatedTitle: "Listing authorized",
      realCreatedBody: "Your signed order is live in the marketplace. It settles on-chain only when a buyer fills it.",
      partialFutureTitle: "Sell a subset (partial)",
      partialFutureBody: "Partial sale requires an on-chain subdivision-vault child token, which is not yet available on Base Sepolia. Only whole-parcel listings are possible right now.",
      priceRealHelp: "Set your asking price in {sym}.",
      listLand: "Land verkaufen",
      sellLand: "Land verkaufen",
      sellLandDemo: "Land verkaufen · Preview Demo",
      previewDemo: "Preview Demo",
      previewDemoGrid: "Grid Preview Demo",
      myLand: "Mein Land",
      selectLand: "Land auswählen",
      pickTitle: "Wähle das Land zum Verkauf",
      pickHint: "Wähle einen deiner Parcels, um eine zusammenhängende Zellen-Teilmenge zum Verkauf anzubieten.",
      pickEmpty: "Kein verkäufliches Land",
      pickEmptyHint: "Du besitzt in dieser Preview kein Land, das für Teilverkauf verfügbar ist.",
      pickCells: "{n} Zellen",
      pickListed: "{n} aktiv",
      pickOpen: "Bereich auswählen →",
      wizardTitle: "Land verkaufen",
      wizardSubtitle: "Parcel #{id} · Preview Demo",
      stepSelect: "Bereich auswählen",
      stepPrice: "Preis",
      stepReview: "Überprüfen",
      selectTitle: "Wähle die zu verkaufenden Zellen",
      selectHint: "Klicke eine Zelle zum Umschalten, oder klicke und ziehe, um ein Rechteck zu malen. Die Auswahl muss ein zusammenhängender Block sein und darf nicht der gesamte Parcel sein.",
      selectedCount: "{n} von {total} Zellen ausgewählt",
      clearSelection: "Löschen",
      valLoading: "Validierung…",
      valValid: "Auswahl gültig",
      valInvalid: "Auswahl ungültig",
      basisLabel: "Anschaffungskosten",
      floorLabel: "Mindest-Wiederverkaufs-Floor (80%)",
      floorBinding: "Bindend",
      floorNotBinding: "Floor nicht bindend (keine Basis erfasst)",
      reasonOutside: "Die Zellen liegen außerhalb des Parcels",
      reasonNotContiguous: "Die Zellen müssen einen zusammenhängenden Block bilden",
      reasonFull: "Das ist der gesamte Parcel — verwende das Angebot für den ganzen Parcel",
      reasonNotOwner: "Du bist nicht der Eigentümer dieses Lands",
      reasonOverlap: "Einige Zellen überlappen ein bestehendes Angebot",
      reasonOccupied: "Einige Zellen sind durch kanonischen Inhalt belegt",
      reasonNoBasis: "Wiederverkaufs-Mindestpreis nicht verfügbar: für dieses Parzelle ist keine Anschaffungskostenbasis erfasst.",
      priceTitle: "Lege deinen Preis fest",
      priceLabel: "Preis",
      currencyLabel: "Währung",
      priceHelpFloor: "Muss mindestens der Floor von {floor} {sym} sein.",
      belowFloor: "Der Preis liegt unter dem Mindest-Floor von {floor} {sym}.",
      reviewTitle: "Überprüfen & autorisieren",
      reviewCells: "Zellen",
      reviewArea: "Bereich",
      reviewFloor: "Floor",
      reviewPrice: "Dein Preis",
      authorize: "Autorisieren & Inserieren",
      authorizeDemo: "Autorisieren (Preview Demo) & Inserieren",
      creating: "Angebot wird erstellt…",
      createdTitle: "Demo-Angebot erstellt",
      createdBody: "Dein Preview-Demo-Angebot ist jetzt in Meine Angebote sichtbar.",
      viewMine: "Zu Meine Angebote",
      demoDisclosureTitle: "Preview Demo — keine On-Chain- / kanonische Änderung",
      demoDisclosureBody: "Dies inseriert einen isolierten Demo-Parcel auf dem Preview-Substrate. Deine SIWE-Session autorisiert den Write; es erfolgt kein On-Chain-Mint des SubdivisionVault, keine EIP-712-Order, kein Settlement auf Base Sepolia. In Produktion signiert derselbe Ablauf mit deinem Wallet und wickelt on-chain ab.",
      back: "Zurück",
      next: "Weiter",
      close: "Schließen",
    },
    artworkMkt: {
      buyNow: "Buy now",
      listedAt: "Listed at",
      fixedPrice: "Fixed price",
      yourListing: "Your listing",
      cancelListing: "Cancel listing",
      sellArtwork: "Sell / List Artwork",
      listArtwork: "List / Sell",
      buyTitle: "Buy “{title}”",
      buySubtitle: "Fixed-price artwork settlement",
      buyIntro: "You are buying this artwork at its listed price. Your wallet locks USDC in escrow, then the sale finalizes on-chain. Nothing moves until you confirm.",
      priceLabel: "Price",
      royaltyLabel: "Creator royalty",
      gridFeeLabel: "Grid fee",
      confirmBuy: "Confirm & buy",
      buyPreparing: "Preparing settlement…",
      buyCheckingAllowance: "Checking USDC allowance…",
      buyApprove: "Approve USDC in your wallet…",
      buyApproving: "Approving USDC…",
      buyOpenWallet: "Confirm escrow in your wallet…",
      buyOpening: "Locking funds in escrow…",
      buyIndexingEscrow: "Confirming escrow on-chain…",
      buyAuthorizing: "Authorizing payout…",
      buyReleaseWallet: "Confirm payout in your wallet…",
      buyReleasing: "Releasing payout on-chain…",
      buyIndexingPayout: "Confirming payout finality…",
      buyFinalizing: "Transferring ownership…",
      buyComplete: "Purchase complete",
      buyCompleteBody: "The artwork is now yours. Ownership and listings refresh shortly.",
      buyRejected: "The action was rejected in your wallet.",
      buyReverted: "The transaction reverted on-chain.",
      buyFailed: "Purchase failed",
      connectBuyer: "Connect the buyer wallet {addr} to complete this purchase.",
      sellIntro: "You own this artwork. List it at a fixed price or open a live auction.",
      cancelListingConfirm: "Cancel this listing?",
      listingCancelled: "Listing cancelled.",
      wizardTitle: "Sell Artwork",
      pickTitle: "Choose an artwork to sell",
      pickHint: "Select a frozen, placed artwork you own that isn't already listed or in auction.",
      pickEmpty: "No sellable artworks",
      pickEmptyHint: "You need a frozen artwork placed on the Grid that isn't already listed or auctioned.",
      chooseMode: "How do you want to sell?",
      modeFixed: "Fixed price",
      modeFixedDesc: "List at a set price. Buyers purchase instantly; you sign nothing on-chain.",
      modeAuction: "Auction",
      modeAuctionDesc: "Run a timed English auction with a reserve. You sign the auction creation on-chain.",
      setPrice: "Set your price",
      priceHint: "Set your asking price in {sym}. Grid fee {fee}% + creator royalty {roy}% are deducted on settlement.",
      listBtn: "List for sale",
      listing: "Listing…",
      listedTitle: "Artwork listed",
      listedBody: "Your artwork is now listed at the fixed price. Buyers can purchase it from its detail page.",
      setAuction: "Auction terms",
      reserveLabel: "Reserve price",
      minIncrementLabel: "Minimum bid increment",
      durationLabel: "Duration",
      antiSnipeLabel: "Anti-snipe window",
      dur1h: "1 hour",
      dur6h: "6 hours",
      dur24h: "24 hours",
      dur3d: "3 days",
      dur7d: "7 days",
      antiSnipe60: "60 seconds",
      antiSnipe300: "5 minutes",
      antiSnipeOff: "Off",
      createAuctionBtn: "Create auction",
      creatingAuction: "Creating auction…",
      auctionWalletConfirm: "Confirm auction in your wallet…",
      auctionSubmitting: "Creating auction on-chain…",
      auctionCreatedTitle: "Auction created",
      auctionCreatedBody: "Your auction is live on-chain. Bidders can place bids until it ends.",
      review: "Review",
      reviewArtwork: "Artwork",
      reviewRoyalty: "Royalty",
      reviewMode: "Mode",
      reviewPrice: "Price",
      reviewReserve: "Reserve",
      reviewIncrement: "Increment",
      reviewEnds: "Ends",
      settleAuction: "Settle auction",
      settling: "Settling…",
      settleWalletConfirm: "Confirm settlement in your wallet…",
      settled: "Auction settled",
      cancelAuction: "Cancel auction",
      cancellingAuction: "Cancelling…",
      auctionCancelled: "Auction cancelled.",
      bidPlacedOnchain: "Bid placed on-chain.",
      bidApprove: "Approve USDC in your wallet…",
      bidApproving: "Approving USDC…",
      bidWalletConfirm: "Confirm bid in your wallet…",
      bidSubmitting: "Placing bid on-chain…",
      historyTitle: "History / Provenance",
      historyEmpty: "No sale or auction history yet for this artwork.",
      histPrepared: "Settlement prepared",
      histFinalized: "Sold (fixed price)",
      histAuctionSettled: "Auction settled",
      histFrozen: "Frozen & placed",
      myArtworkListings: "My Artwork Listings",
      noArtworkListings: "No artwork listings",
      noArtworkListingsHint: "List a frozen artwork for sale to see it here.",
      myAuctions: "My Auctions",
      noMyAuctions: "No auctions",
      noMyAuctionsHint: "Create an auction from an artwork you own to see it here.",
      close: "Close",
      cancel: "Cancel",
      back: "Back",
      next: "Next",
      done: "Done",
      viewTx: "View tx →",
      signInFirst: "Connect your wallet & sign in →",
      auctionEnds: "Ends {when}",
    },
    demoGrid: {
      title: "Grid Preview Demo",
      subtitle: "Dein Demo-Land · isoliertes Preview-Substrate",
      disclosure: "Dies ist eine isolierte PREVIEW-DEMO-Oberfläche — nicht die kanonische Grid. Nichts hier berührt echte Parcels, On-Chain-Eigentum oder Base Sepolia.",
      empty: "Du hast in dieser Preview kein Demo-Land.",
      emptyHint: "Melde dich mit dem Demo-Verkäufer-Wallet an, um verkäufliches Demo-Land zu sehen.",
      returnToMarket: "← Zurück zum Marketplace",
      ownedBadge: "Deins",
      listedBadge: "{n} inseriert",
      clickToSell: "Klicke einen Parcel, um einen Teil davon zu verkaufen",
      worldLabel: "Welt 1000 × 1000",
      loadError: "Dein Demo-Land konnte nicht geladen werden",
    },
    clock: {
      closing: "schließt",
      ended: "Beendet",
    },
    grid: {
      cellAria: "Zelle {x},{y}",
      cellLockedAria: "Zelle {x},{y} (gesperrt)",
    },
  },
  purchase: {
    intro: "Live-Angebotsvorschau — es wird nichts berechnet, bis du bestätigst.",
    loading: "wird geladen…",
    bootstrapError: "/sale/config oder /sale/status konnte nicht geladen werden: {error}",
    recovery: {
      confirming: "Ausstehender Kauf wiederhergestellt — Bestätigung auf Base…",
      syncing: "On-chain bestätigt — Synchronisierung mit der Grid…",
      failed: "Die wiederhergestellte Kauftransaktion wurde zurückgesetzt. Es wurde keine Parzelle gekauft.",
      degraded: "Netzwerk vorübergehend nicht verfügbar — Kaufstatus wird erneut versucht…",
    },
    sections: {
      contracts: "On-chain-Verträge",
      saleStatus: "Verkaufsstatus",
      wallet: "Wallet",
      financial: "USDC-Guthaben & Freigabe",
      approval: "USDC-Freigabe",
      purchase: "Kauf",
      indexing: "Indizierung",
      quote: "Angebot",
    },
    gate: { yes: "JA", no: "NEIN ({reason})" },
    wallet: {
      connect: "{name} verbinden",
      disconnect: "Trennen",
      wrongChain: "Die Wallet ist auf Chain {chainId}, der Verkauf ist auf {expectedChainId}. Wechsle das Netzwerk in deiner Wallet.",
      switching: "Wird gewechselt…",
      switchTo: "Zu Chain {chainId} wechseln",
      switchRejected: "Wechsel abgelehnt",
      switchError: "Wechselfehler: {message}",
    },
    financial: {
      blocked: "Lesevorgänge deaktiviert: {reason}",
      readError: "Lesefehler",
      noSellableQuote: "— (kein verkäufliches Angebot)",
      insufficient: "insufficient_balance (es fehlen {amount})",
      approval: "approval_required (benötigt {amount})",
      ready: "ready_for_purchase",
      rpcError: "RPC-Fehler beim Lesen des USDC-Status.",
      refetch: "Guthaben/Freigabe neu laden",
    },
    approve: {
      blocked: "Freigabe deaktiviert: {reason}",
      waitingWallet: "Warte auf Wallet…",
      submitting: "Wird gesendet…",
      confirming: "Wird bestätigt…",
      cta: "Exakte USDC freigeben",
      rejected: "Der Nutzer hat die Freigabetransaktion abgelehnt. Du kannst es erneut versuchen.",
      reverted: "Die Freigabetransaktion wurde on-chain zurückgesetzt.",
      error: "Freigabefehler: {error}",
      confirmed: "Freigabe bestätigt. Neuladen der Freigabe und erzwungenes neues Angebot ausgelöst.",
    },
    tx: {
      blocked: "Kauf deaktiviert: {reason}",
      refreshingQuote: "Endgültiges Angebot wird aktualisiert…",
      awaitingWallet: "Bestätige in deiner Wallet…",
      submitted: "Gesendet…",
      confirming: "Bestätigung auf Base…",
      cta: "Kaufen",
      rejected: "Der Nutzer hat die Kauftransaktion abgelehnt.",
      reverted: "Transaktion zurückgesetzt",
      revertedReason: "Transaktion zurückgesetzt: {reason}",
      error: "Kauffehler: {error}",
      confirmed: "Transaktion on-chain bestätigt. Synchronisierung mit der Grid — warte auf Backend-Indizierung…",
    },
    indexing: {
      pending: "Synchronisierung mit der Grid…",
      delayed: "Transaktion on-chain bestätigt. Die Backend-Indizierung dauert länger als erwartet.",
      checkAgain: "Erneut prüfen",
      success: "Im Besitz · Live. Kauf erfolgreich indiziert.",
      buyAnother: "Weitere Parzelle kaufen",
      anomaly: "Indizierungsanomalie erkannt ({reason}). Die On-chain-Transaktion ist bestätigt, aber der indizierte Datensatz stimmt nicht mit dem ursprünglichen Kauf-Snapshot überein. Bitte kontaktiere den Support mit dem untenstehenden Transaktions-Hash.",
    },
    quote: {
      empty: "Zeichne ein Rechteck auf dem Raster, um ein Angebot zu erhalten.",
      clearSelection: "Auswahl löschen",
      occupiedSelf: "Dieser Bereich überschneidet sich mit einer Parzelle, die dir bereits gehört. Bereits geprägtes Land kann nicht erneut gekauft werden.",
      occupiedOther: "Dieser Bereich überschneidet sich mit Land einer anderen Wallet. Zeichne über freies Raster, um zu kaufen.",
      occupiedGeneric: "Dieser Bereich überschneidet sich mit bestehenden Parzellen und ist nicht kaufbar. Zeichne über freies Raster.",
      loading: "Angebot wird geladen…",
    },
    errors: {
      tooWide: "Auswahl zu breit — eine einzelne Parzelle darf höchstens 250 Zellen breit sein. Zeichne einen schmaleren Bereich.",
      tooHigh: "Auswahl zu hoch — eine einzelne Parzelle darf höchstens 250 Zellen hoch sein. Zeichne einen niedrigeren Bereich.",
      areaExceeds: "Auswahl zu groß — eine einzelne Parzelle kann höchstens 10.000 Slots (Zellen) abdecken{yours}. Zeichne einen kleineren Bereich, um ein Angebot zu erhalten.",
      areaExceedsYours: " — deine hat {slots} Slots",
      outOfBounds: "Die Auswahl reicht über den Rand der Grid hinaus. Halte sie vollständig innerhalb des Territoriums 1000 × 1000.",
      zeroOrNegative: "Die Auswahl ist leer — zeichne ein Rechteck von mindestens einer Zelle Breite.",
      vipCap: "Dieser VIP-Bereich überschreitet die kommerzielle Obergrenze pro Parzelle. Zeichne einen kleineren Bereich.",
      zoneCap: "Dieser Bereich überschreitet die verbleibende Kapazität seiner Zone. Zeichne einen kleineren Bereich.",
      unexpected: "Unerwarteter Fehler.",
    },
  },
  profile: {
    badge: { none: "Noch kein Abzeichen" },
    cockpit: {
      title: "Übersicht",
      available: "Verfügbar",
      pendingFunding: "Ausstehende Finanzierung",
      ownedParcels: "Besessene Parzellen",
      influence: "Einfluss",
      lifetimePts: "Gesamtpunkte",
      slots: "{n} Slots",
      progressTo: "Fortschritt bis {badge}",
      max: "max",
      referralCode: "Empfehlungscode",
      qualified: "{n} qualifiziert",
      pending: "{n} ausstehend",
    },
    myGrid: {
      loading: "Dein Raster wird geladen…",
      signIn: "Anmelden",
      unavailable: "Nicht verfügbar.",
      failedToLoad: "Laden fehlgeschlagen",
      retry: "Erneut versuchen",
      title: "Mein Grid",
      empty: "Du besitzt noch kein Land. Erwirb eine Parzelle, um Nachbarschafts-Belohnungen und Einfluss zu verdienen.",
      parcels: "Parzellen",
      totalSlots: "Slots insgesamt",
      clusters: "Cluster",
      largestCluster: "Größtes Cluster",
      slots: "{n} Slots",
      parcelMeta: "{w}×{h} · {area} Slots",
      edgeNeighbors: "{n} Kantennachbarn",
    },
    influence: {
      title: "Einfluss-Punktzahl",
      lifetimePrivate: "Gesamtpunkte · privat",
      ptsTo: "{points} Pkt. bis ",
      maxReached: "Höchstes Abzeichen erreicht",
      nextAt: "nächstes bei {threshold}",
      publicNote: "Öffentliche Flächen zeigen nur dein Abzeichen — nie deine exakte Punktzahl. Keine Rangliste.",
    },
    analytics: {
      title: "Analysen",
      retry: "Erneut versuchen",
      loadError: "Deine Analysen konnten nicht geladen werden.",
      sections: { land: "Land & Besitz", creator: "Creator & Empfehlung", trends: "Trends", rewards: "Belohnungen & Einfluss" },
      kpi: {
        parcelsOwned: "Besessene Parzellen",
        totalArea: "Gesamtfläche",
        primaryAcq: "Primäre Erwerbe",
        acqVolume: "Erwerbsvolumen",
        ownedTerritories: "Besessene Territorien",
        publishedTerritories: "Veröffentlichte Territorien",
        createdArtworks: "Erstellte Werke",
        qualifiedReferrals: "Qualifizierte Empfehlungen",
        influence: "Einfluss",
        rewardsAvailable: "Verfügbare Belohnungen",
        totalRewards: "Gesamtbelohnungen",
        pendingFunding: "Ausstehende Finanzierung",
      },
      cells: "Zellen",
      referralQ: "Empfehlungs-Qualifikationen",
      inRange: "{n} im Zeitraum",
      noReferrals: "Noch keine qualifizierten Empfehlungen in diesem Zeitraum.",
      rewardsByType: "Belohnungen nach Typ",
      influenceGrowth: "Einfluss-Wachstum",
      noInfluence: "Noch kein Einfluss in diesem Zeitraum.",
      notLiveTitle: "Belohnungen & Einfluss sind noch nicht aktiv.",
      notLiveBody: "Diese Kennzahlen füllen sich automatisch, sobald das The Grid Rewards-Programm live geht. Bis dahin wird nichts erfasst oder geschätzt.",
    },
    activity: {
      title: "Aktivität",
      markAll: "Alle als gelesen markieren ({n})",
      filters: { all: "Alle", rewards: "Belohnungen", land: "Land", artwork: "Werke", account: "Konto" },
      loadError: "Deine Aktivität konnte nicht geladen werden.",
      retry: "Erneut versuchen",
      empty: "Noch keine Aktivität. Wichtige Ereignisse auf deiner Grid erscheinen hier.",
      loading: "Wird geladen…",
      loadMore: "Mehr laden",
    },
    rewards: {
      loading: "Belohnungen werden geladen…",
      failedToLoad: "Belohnungen konnten nicht geladen werden",
      auth: { note: "Melde dich an, um dein Belohnungsguthaben und deine Auszahlungen zu sehen.", cta: "Zur Anmeldung" },
      unavailable: "Belohnungen nicht verfügbar.",
      retry: "Erneut versuchen",
      errors: {
        belowMin: "Der Betrag liegt unter dem Minimum von 350 USDC.",
        exceedsAvailable: "Der Betrag übersteigt dein verfügbares Guthaben.",
        invalidAmount: "Gib einen gültigen Betrag ein.",
        unauthenticated: "Deine Sitzung ist abgelaufen — melde dich erneut an.",
        failed: "Auszahlung fehlgeschlagen.",
      },
      balance: {
        title: "Belohnungsguthaben",
        available: "Verfügbar",
        pendingFunding: "Ausstehende Finanzierung",
        awaitingVault: "Warten auf Vault-Finanzierung",
        withdrawalPending: "Auszahlung ausstehend",
        withdrawn: "Ausgezahlt",
        expired: "Abgelaufen",
        expiryDeadline: "Ablauffrist",
        forfeits: "Verfügbares verfällt, wenn nicht beansprucht",
        noTimer: "Kein aktiver Timer",
      },
      withdraw: {
        title: "Auszahlen",
        disabledNote: "Du brauchst mindestens {min} Verfügbar, um auszuzahlen. Aktuell verfügbar: {available}.",
        amountLabel: "Betrag (USDC)",
        gasLabel: "Netzwerk-Gas-Schätzung (USDC · optional)",
        allToggle: "Gesamtes Verfügbares auszahlen ({available})",
        serviceFee: "Servicegebühr · 2%",
        gasSeparate: "Gas (separat)",
        estimatedNet: "Geschätzter Netto",
        minNote: "Mindestens {min} brutto. Es fällt eine Servicegebühr von 2% an; Netzwerk-Gas wird separat berechnet und ist nur eine Schätzung.",
        belowMin: "Unter dem Minimum von 350 USDC.",
        exceeds: "Übersteigt dein verfügbares Guthaben.",
        submitting: "Wird gesendet…",
        submit: "Auszahlen",
        all: "Alles auszahlen",
        success: "Auszahlung angefordert — netto {net} (Gebühr {fee}, Gas {gas}).",
      },
      payout: {
        title: "Hilfe beim Abrechnen nötig?",
        body: "Benachrichtige das Team, dein verfügbares Guthaben ({available}) zu verarbeiten. Dies schafft kein Geld und umgeht nie die Finanzierungsreihenfolge.",
        reachTitle: "Erreiche {min} an verfügbaren Gewinnen, um eine Auszahlung anzufordern",
        sending: "Wird gesendet…",
        cta: "Auszahlung anfordern",
        minHint: "Erreiche {min} an verfügbaren Gewinnen, um eine Auszahlung anzufordern — du hast {available}.",
        alreadyOpen: "Eine Auszahlungsanfrage ist bereits offen.",
        sent: "Auszahlungsanfrage an das Team gesendet.",
        failed: "Anfrage konnte nicht gesendet werden.",
      },
      history: {
        title: "Belohnungsverlauf",
        empty: "Noch keine Belohnungen. Empfehlungs- (7%) und Nachbarschafts-Belohnungen (3%) erscheinen hier, sobald Land erworben wird.",
        referralProv: "Empfehlung · {pct}% von {gross}",
        neighborProvEdge: "Nachbarschaft · {edge}/{total} Kante eines {pct}%-Pools",
        neighborProvPool: "Nachbarschaft · {pct}%-Pool",
        funded: "Finanziert",
        pendingFunding: "Ausstehende Finanzierung",
        parcels: "Parzellen {ids}",
      },
      withdrawals: {
        title: "Auszahlungen",
        pending: "Ausstehend",
        withdrawn: "Ausgezahlt",
        failed: "Fehlgeschlagen",
        net: "{net} netto",
        gross: "brutto {x}",
        fee: "Gebühr {x}",
        gas: "Gas {x}",
        failureReason: "· {reason} — zur erneuten Auszahlung ins Verfügbare zurückgebucht",
      },
    },
  },
  dashboard: {
    publishability: { published: "Veröffentlicht", publishable: "Veröffentlichbar", notPublishable: "Nicht veröffentlichbar" },
    territory: { fallback: "Territorium {ordinal}" },
    route: {
      title: "Meine Territorien",
      subtitle: "Kommandozentrale des Eigentümers · abgeleitet aus deinem realen Besitz im Grid",
      backToGrid: "Zurück zum Grid",
      authTitle: "Authentifizierung erforderlich",
      authBody: "Melde dich mit deinem Wallet an, um deine Territorien zu verwalten. Ein Wallet zu verbinden genügt nicht — eine signierte Sitzung ist erforderlich.",
      signIn: "Mit Ethereum anmelden",
      detailEmpty: "Wähle ein Territorium, um seine Verwaltungsübersicht anzuzeigen.",
    },
    list: {
      resolving: "Deine Territorien werden aufgelöst…",
      unavailableTitle: "Territorien nicht verfügbar",
      unavailableBody: "Deine vollständigen Besitzdaten konnten gerade nicht aufgelöst werden. Es wird nichts Teilweises angezeigt. Bitte versuche es in Kürze erneut.",
      emptyTitle: "Noch keine Territorien",
      emptyBody: "Du besitzt noch keinen Grundbesitz im Grid.",
      exploreGrid: "Grid erkunden",
    },
    card: {
      area: "Fläche",
      gpCapacity: "GP-Kapazität",
      propertyUnits: "Eigentumseinheiten",
      minNote: "Mindestens 400 u² zum Veröffentlichen.",
      unreadTitle: "Ein Administrator hat dir eine Moderationsnachricht gesendet",
      unreadAria: "Ungelesene Moderationsnachricht",
    },
    detail: {
      territoryArea: "Territoriumsfläche",
      gpCapacity: "GP-Kapazität",
      propertyUnits: "Eigentumseinheiten",
      underlyingUnitIds: "Zugrunde liegende Einheiten-IDs",
      location: "Standort (Weltgrenzen)",
      minNote: "Dieses Territorium liegt unter dem zum Veröffentlichen erforderlichen Minimum von 400 u².",
    },
    identity: {
      title: "Territoriums-Identität",
      rev: "Rev {n}",
      authRequired: "Zum Verwalten der Identität dieses Territoriums ist eine signierte Sitzung erforderlich.",
      unavailable: "Die Identitätsverwaltung ist nur für ein rechtmäßig besessenes Territorium verfügbar.",
      loading: "Aktuelles Territorium wird aufgelöst…",
      namePlaceholder: "Anzeigename — benenne dieses Territorium",
      saved: "Gespeichert.",
      saving: "Speichern…",
      saveName: "Namen speichern",
      editCanvas: "Canvas bearbeiten →",
      saveErrors: {
        STALE_TERRITORY: "Dein Territorium hat sich seit dem Laden geändert. Es wurde aktualisiert — bitte prüfen und erneut speichern.",
        IDENTITY_VERSION_CONFLICT: "Diese Identität wurde anderswo aktualisiert. Sie wurde aktualisiert — bitte prüfen und erneut speichern.",
        IDENTITY_RECONCILIATION_REQUIRED: "Dieses Territorium verschmilzt nun mit einem anderen benannten Territorium. Vor dem Speichern ist eine Abstimmung erforderlich.",
        TERRITORY_NOT_PUBLISHABLE: "Dieses Territorium liegt unter dem zum Veröffentlichen erforderlichen Minimum von 400 u².",
        TERRITORY_NOT_IDENTITY_ELIGIBLE: "Die Identitätsverwaltung ist nur für ein rechtmäßig besessenes Territorium verfügbar.",
        DISPLAY_NAME_INVALID: "Dieser Name ist nicht zulässig.",
        UNTRUSTED_ORIGIN: "Diese Anfrage wurde aus Sicherheitsgründen blockiert. Bitte lade die Seite neu und versuche es erneut.",
        CSRF_REQUIRED: "Dein Sicherheitstoken fehlte. Bitte lade die Seite neu und versuche es erneut.",
        CSRF_INVALID: "Dein Sicherheitstoken ist abgelaufen. Bitte lade die Seite neu und versuche es erneut.",
        CSRF_FETCH_FAILED: "Deine Sitzung konnte nicht verifiziert werden. Bitte lade die Seite neu und versuche es erneut.",
        UNAUTHENTICATED: "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an, um zu speichern.",
        UNSUPPORTED_MEDIA_TYPE: "Beim Senden deiner Anfrage ist etwas schiefgelaufen. Bitte lade neu und versuche es erneut.",
        SEED_NOT_OWNED: "Du besitzt dieses Territorium nicht mehr.",
      },
    },
    reconciliation: {
      intro: "Dieses Territorium verschmilzt nun {n} benannte Territorien zu einem. Wähle, welche Identität bestehen bleibt — die anderen werden ersetzt. Namen werden nicht zusammengeführt.",
      metaOne: "{n} Einheit · Rev {rev}",
      metaOther: "{n} Einheiten · Rev {rev}",
      reconciling: "Abstimmung…",
      confirmSurvivor: "Verbleibende bestätigen",
      errors: {
        STALE_TERRITORY: "Dein Territorium hat sich seit dem Laden geändert. Es wurde aktualisiert — bitte prüfen und erneut wählen.",
        IDENTITY_VERSION_CONFLICT: "Eine dieser Identitäten wurde anderswo geändert. Sie wurde aktualisiert — bitte prüfen und erneut wählen.",
        RECONCILIATION_NOT_REQUIRED: "Dieses Territorium benötigt keine Abstimmung mehr. Es wurde aktualisiert.",
        SURVIVOR_NOT_CANDIDATE: "Diese Identität ist nicht mehr berechtigt. Sie wurde aktualisiert.",
        TERRITORY_NOT_PUBLISHABLE: "Dieses Territorium liegt unter dem zum Veröffentlichen erforderlichen Minimum von 400 u².",
        UNTRUSTED_ORIGIN: "Diese Anfrage wurde aus Sicherheitsgründen blockiert. Bitte lade die Seite neu und versuche es erneut.",
        CSRF_REQUIRED: "Dein Sicherheitstoken fehlte. Bitte lade die Seite neu und versuche es erneut.",
        CSRF_INVALID: "Dein Sicherheitstoken ist abgelaufen. Bitte lade die Seite neu und versuche es erneut.",
        CSRF_FETCH_FAILED: "Deine Sitzung konnte nicht verifiziert werden. Bitte lade die Seite neu und versuche es erneut.",
        UNAUTHENTICATED: "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.",
        TRANSACTION_UNAVAILABLE: "Der Dienst ist kurzzeitig nicht verfügbar. Bitte versuche es gleich erneut.",
        SEED_NOT_OWNED: "Du besitzt dieses Territorium nicht mehr.",
      },
    },
    brandImage: {
      title: "Markenbild · LOD0",
      rev: "Rev {n}",
      desc: "Optionales Kartenbild für dieses Territorium (PNG · JPEG · WebP, ≤ 5 MiB, ≤ 2048px). Kostenlos.",
      recommendedPrefix: "Empfohlen für dein Territorium:",
      size: "{rw} × {rh} px",
      ratioNote: "(Verhältnis {ratio}) — passt zu deiner Parzelle, damit das Logo nicht verzerrt wird.",
      previewAlt: "Markenbild des Territoriums",
      unsaved: "Nicht gespeicherte Vorschau — drücke Speichern, um sie zu behalten.",
      empty: "Noch kein Markenbild.",
      saved: "Gespeichert.",
      removed: "Markenbild entfernt.",
      authRequired: "Zum Verwalten des Markenbilds ist eine signierte Sitzung erforderlich.",
      chooseAria: "Wähle ein Markenbild",
      replace: "Ersetzen…",
      select: "Bild auswählen…",
      saving: "Speichern…",
      save: "Speichern",
      cancel: "Abbrechen",
      remove: "Entfernen",
      removeConfirm: "Markenbild entfernen?",
      removing: "Entfernen…",
      confirm: "Bestätigen",
      keep: "Behalten",
    },
    publish: {
      publishing: "Veröffentlichen…",
      republish: "Erneut veröffentlichen",
      published: "Veröffentlicht",
      publish: "Veröffentlichen",
      blockedSave: "Speichere deinen Entwurf vor dem Veröffentlichen",
      stateLabels: {
        UNPUBLISHED: "Nicht veröffentlicht",
        PUBLISHED_CURRENT: "Veröffentlicht · aktuell",
        DRAFT_CHANGED: "Veröffentlicht · Entwurf geändert",
        TERRITORY_CHANGED: "Veröffentlicht · Territorium geändert",
      },
    },
    media: {
      fileTooLarge: "Die Datei ist größer als das Maximum von 250 MiB.",
      title: "Medienbibliothek",
      subtitle: "Wiederverwendbare Medien deines Wallets · Bild 10 · GIF 20 (10s) · PDF 25 · Video 250 MiB · Bibliothek 2 GiB",
      working: "Wird bearbeitet…",
      upload: "Hochladen",
      used: "{x} belegt",
      free: "{free} frei von {total}",
      loading: "Bibliothek wird geladen…",
      empty: "Noch keine Medien. Lade ein Bild, GIF, PDF oder Video hoch, um deine Bibliothek zu starten.",
      loadMore: "Mehr laden",
      pages: "{n} Seiten",
      deleteAria: "Asset löschen",
    },
  },
  artist: {
    utility: {
      loading: "Parzellen-Utility wird geladen…",
      referral: {
        title: "Empfehlung",
        yourCode: "Dein Empfehlungscode",
        copyLink: "Empfehlungslink kopieren",
        copied: "Kopiert",
        qualified: "Qualifizierte Empfehlungen",
        pending: "Ausstehende Empfehlungen",
        empty: "Noch keine Empfehlungen. Teile deinen Link — eine Empfehlung qualifiziert sich, sobald dein Eingeladener seinen ersten primären Landerwerb tätigt.",
        preparing: "Dein Empfehlungscode wird aus dem kanonischen Besitz vorbereitet — schau gleich wieder vorbei.",
        ownToUnlock: "Besitze mindestens eine Parzelle, um deinen Empfehlungscode freizuschalten.",
        wasReferred: "Du wurdest empfohlen · Status",
      },
      parcel: {
        title: "Parzellen-Utility",
        empty: "Du besitzt derzeit keine Parzelle. Erwirb Land, um die Parzellen-Utility freizuschalten.",
        parcels: "Parzellen",
        totalArea: "Gesamtfläche",
        clusters: "Cluster",
        largestCluster: "Größter Cluster",
        flagBasicIdentity: "Basis-Identität",
        flagPublishable: "Veröffentlichbar",
        flagPublished: "Veröffentlicht",
        flagHasNeighbors: "Hat Nachbarn",
        neighbors: "{n} Nachbarn",
        cluster: "Cluster {size} · {area} u²",
      },
      neighborhood: {
        title: "Nachbarschaft",
        empty: "Besitze eine Parzelle, um deine Nachbarschaft zu sehen.",
        edgeNeighbors: "Kantennachbarn",
        connectedClusters: "Verbundene Cluster",
        connectedClusterLabel: "Verbundener Cluster",
        clusterSummary: "{size} Parzellen · {area} u²",
        openParcel: "Parzelle #{id} — {n} Kantennachbar(n)",
        loading: "Wird geladen…",
        noEdgeNeighbors: "Keine Kantennachbarn.",
        yours: "deine",
        published: "veröffentlicht",
      },
    },
    profile: {
      loading: "Profil wird geladen…",
      connectWallet: "Verbinde dein Wallet",
      connectBody: "Melde dich an, um dein Künstlerprofil, deine Berechtigung und deine kreative Kapazität anzuzeigen.",
      goToSignIn: "Zur Anmeldung",
      unavailable: "Profil nicht verfügbar.",
      retry: "Erneut versuchen",
      loadFail: "Profil konnte nicht geladen werden",
      moderationLabel: "Moderation",
      moderationMsg: "Nachricht vom Admin",
      moderationAria: "Du hast eine Nachricht von einem Administrator — öffne Meine Territorien, um sie zu lesen",
      tabs: { overview: "Übersicht", rewards: "Belohnungen", activity: "Aktivität", analytics: "Analysen", grid: "Mein Grid" },
      roleTitle: "Rolle",
      roleArtist: "Du bist ein Künstler — eine permanente Identität, die durch Land-Berechtigung und Dauer erworben wurde.",
      roleNeo: "Du bist ein NeoKünstler — eine permanente Identität mit beschleunigtem Zugang zur Künstler-Erstellung, sobald du berechtigt bist. Dieselben kreativen Fähigkeiten wie ein Künstler.",
      roleCreator: "Du besitzt derzeit Land, also kannst du die kreativen Werkzeuge nutzen. Ersteller ist ein aktueller Zustand — er folgt deinem Landbesitz und ist kein permanentes Abzeichen.",
      roleUser: "Du besitzt derzeit kein Land und hast keine permanente künstlerische Identität freigeschaltet. Erwirb Land, um Ersteller zu werden, oder erreiche 50 % Berechtigung für den NeoKünstler-Pfad.",
      statusCurrentState: "· aktueller Zustand",
      eligTitle: "Künstler-Berechtigung",
      neoThreshold: "NeoKünstler-Schwelle · 50%",
      artistThreshold: "Künstler-Schwelle · 100%",
      eligUnits: "{units} / {total} Berechtigungseinheiten",
      tierSlots: "{slots} Slots · {units}u",
      tenureTitle: "Künstler-Dauer · 100 Tage",
      tenureBlock: " (Block {block})",
      tenurePending: "Erster Landerwerb on-chain erfasst{block}. Das genaue Datum wird aus kanonischen Chain-Daten aufgelöst — die Dauer wird angezeigt, sobald verfügbar. Es wird kein Datum angezeigt, bis es belegt werden kann.",
      firstAcq: "Erster Erwerb: {date}",
      daysLine: "{days} / {min} Tage",
      reqMet: "Anforderung erfüllt",
      daysRemaining: "{n} Tage verbleibend",
      ccTitle: "Kreative Kapazität",
      ccTotal: "Gesamt",
      ccUsed: "Genutzt",
      ccAvailable: "Verfügbar",
      ccNote: "Die Kapazität stammt aus deinem besessenen Land und bleibt an die Historie jeder Parzelle gebunden.",
      neoTitle: "NeoKünstler-Pfad",
      neoHavePermanent: "Du besitzt bereits eine permanente {status}-Identität.",
      neoNeedElig: "Erreiche 50% Künstler-Berechtigung, um den beschleunigten NeoKünstler-Pfad freizuschalten (derzeit {pct}%).",
      neoEligibleBody: "Du bist für den beschleunigten NeoKünstler-Pfad berechtigt (einmalige Gebühr, in USDC oder USDT). NeoKünstler gewährt keine zusätzliche kreative Kapazität.",
      neoFee: "Gebühr: {fee} · {currencies}",
      neoFeeNotConfigured: "Gebühr noch nicht konfiguriert — es wird kein Preis angezeigt, bis The Grid ihn festlegt.",
      neoPaymentPending: "Zahlungsintegration ausstehend",
      collectionTitle: "Sammlung",
      collCreatedBy: "Erstellt von",
      collOwned: "Im Besitz",
      collCreatedCount: "{n} erstellt",
      collCreatedEmpty: "Noch keine eingefrorenen Werke.",
      collOwnedEmpty: "Derzeit keine Werke im Besitz.",
      editTitle: "Profil bearbeiten",
      editDisplayName: "Anzeigename",
      editBio: "Bio",
      editAvatar: "Avatar-URL (https/ipfs)",
      editSaving: "Speichern…",
      editSave: "Speichern",
      editSaved: "Gespeichert",
      editSaveFail: "Speichern fehlgeschlagen",
    },
  },
  social: {
    follow: { follow: "Folgen", following: "Gefolgt", actionFailed: "Aktion fehlgeschlagen" },
    report: {
      moreOptions: "Weitere Optionen",
      reason: "Grund",
      report: "Melden",
      blockUser: "Nutzer blockieren",
      reported: "Gemeldet. Danke.",
      reportFailed: "Meldung fehlgeschlagen",
      blocked: "Blockiert.",
      blockFailed: "Blockieren fehlgeschlagen",
      reasons: {
        spam: "Spam", abuse: "Missbrauch", harassment: "Belästigung", hate: "Hass",
        nsfw: "NSFW", scam: "Betrug", impersonation: "Identitätsdiebstahl", other: "Sonstiges",
      },
    },
    bar: {
      save: "Speichern", saved: "Gespeichert", comments: "Kommentare",
      likeError: "Like konnte nicht aktualisiert werden", saveError: "Speichern konnte nicht aktualisiert werden",
    },
    comment: {
      post: "Posten", postError: "Konnte nicht gepostet werden", removed: "[entfernt]", you: "du",
      reply: "Antworten", hide: "Ausblenden", viewOne: "{n} Antwort anzeigen", viewMany: "{n} Antworten anzeigen",
      delete: "Löschen", loadingReplies: "Antworten werden geladen…", replyPlaceholder: "Schreibe eine Antwort…",
      heading: "Kommentare", topPlaceholder: "Teile deine Gedanken zu diesem Territorium…",
      signin: "Melde dich an, um mitzudiskutieren →", loading: "Kommentare werden geladen…",
      empty: "Noch keine Kommentare. Sei der Erste.", loadingMore: "Wird geladen…", loadMore: "Mehr laden",
    },
    creator: {
      signinPre: "Anmelden", signinPost: "um dein Profil anzuzeigen.",
      none: "Kein Ersteller angegeben.", loading: "Profil wird geladen…", unavailable: "Profil nicht verfügbar.",
      followers: "Follower", following: "Folgt", likes: "Likes", comments: "Kommentare",
      territories: "Territorien", published: "Veröffentlicht",
      gotoFeed: "Zu deinem Feed →", recentActivity: "Letzte Aktivität",
    },
    feed: {
      title: "Social", yourProfile: "Dein Profil →",
      following: "Folge ich", discover: "Entdecken",
      followingSignin: "Melde dich an, um die Ersteller zu sehen, denen du folgst →",
      loading: "Feed wird geladen…", unavailable: "Feed nicht verfügbar.",
      emptyFollowing: "Dein Feed ist ruhig. Folge Erstellern, um hier ihre neuesten Territorien und Werke zu sehen.",
      emptyDiscover: "Noch nichts zu entdecken — neu veröffentlichte Territorien erscheinen hier.",
      loadingMore: "Wird geladen…", loadMore: "Mehr laden",
      titlePublication: "Hat ein Territorium veröffentlicht",
      titleArtworkNamed: "Hat das Werk „{title}“ veröffentlicht",
      titleArtwork: "Hat ein Werk veröffentlicht",
      titleAcquiredParcel: "Hat Parzelle #{id} erworben",
      titleAcquired: "Hat ein neues Territorium erworben",
    },
    handle: {
      heading: "Dein Social-Profil", handleLabel: "Handle", handlePlaceholder: "dein_handle",
      save: "Speichern", handleSaved: "Handle gespeichert.", handleError: "Handle konnte nicht gespeichert werden",
      handleHint: "3–24 Zeichen · Buchstaben, Ziffern, Unterstrich · alle 30 Tage änderbar.",
      linksLabel: "Links", linkLabelPlaceholder: "Bezeichnung", addLink: "+ Link hinzufügen",
      saveLinks: "Links speichern", linksSaved: "Links gespeichert.", linksError: "Links konnten nicht gespeichert werden",
    },
  },
  legal: {
    navAria: "Navigation der Rechtsdokumente",
  },
  editor: {
    pixel: {
      title: "Pixel Studio",
      deleteTitle: "Dieses Pixel-Art löschen",
      delete: "Löschen",
      closeTitle: "Studio schließen",
      startingPoint: "Startpunkt",
      startingPointBody: "Wir haben dein Bild in Pixel umgewandelt, um dir eine Basis zu geben. Mach es jetzt zu deinem…",
      pencil: "Stift", eraser: "Radierer", fill: "Füllen", pick: "Pipette",
      undo: "Rückgängig", redo: "Wiederholen", clear: "Leeren", grid: "Raster",
      importOpen: "Bild importieren → Pixel",
      brush: "Pinsel", zoom: "Zoom",
      zoomOutTitle: "Zoom − (kleinere Zellen)", zoomInTitle: "Zoom + (größere Zellen)",
      cellsPainted: "Gemalte Zellen:",
      paletteActive: "Aktive Palette", paletteActiveNote: "· importiertes Bild / Zeichnung",
      add: "+ Hinzufügen", recent: "Zuletzt",
      paletteBase: "Basispalette", paletteBaseNote: "· Standardfarben THE GRID",
      saving: "Speichern…", saveArtworkCanvas: "Werk + Canvas speichern",
      unsaved: "Nicht gespeichert", saved: "Gespeichert", close: "Schließen",
      pixelizeTitle: "Bild pixeln", cancel: "Abbrechen",
      resultingGrid: "Resultierendes Raster:", colorsLabel: "Farben:",
      resolution: "Auflösung (lange Seite)", fitMode: "Anpassung",
      fitContain: "Einpassen", fitCover: "Füllen", maxColors: "Max. Farben",
      dithering: "Dithering", on: "AN", off: "AUS",
      alphaThreshold: "Transparenzschwelle ({v})", useAsBase: "Als Basis verwenden",
      unsavedTitle: "Nicht gespeicherte Änderungen",
      unsavedBody: "Du hast Pixel-Art-Änderungen, die noch nicht im Canvas gespeichert sind. Was möchtest du tun?",
      saveAndClose: "Speichern und schließen", discardClose: "Ohne Speichern schließen",
    },
    voxel: {
      invalid: "Ungültige 3D-Editor-Route.",
      authRequired: "Melde dich mit deinem Wallet an, um diese 3D-Szene zu bearbeiten.",
      signIn: "Anmelden →",
      loading: "3D-Editor wird geladen…",
      back: "Zurück",
      empty: "Kein Territorium.",
      failedToLoad: "Laden fehlgeschlagen",
      noFootprint: "Dieses Territorium hat keine eigenen Parzellen zum Bauen.",
      flashCreateFirst: "Erstelle oder wähle zuerst ein Werk",
      flashOutside: "Außerhalb deines eigenen Grundrisses",
      flashCleared: "Aktives Stück geleert",
      flashNoImage: "Bild konnte nicht gelesen werden",
      flashBaseInside: "Die Basis muss innerhalb deines Territoriums bleiben",
      canvas: "Canvas",
      add: "Hinzufügen", remove: "Entfernen", cancelBase: "Basis abbrechen",
      currentColorTitle: "Aktuelle Farbe (ändere sie in der Seitenleiste)",
      undo: "Rückgängig", undoTitle: "Rückgängig (Strg+Z)",
      redo: "Wiederholen", redoTitle: "Wiederholen (Strg+Umschalt+Z)",
      clear: "Leeren", clearTitle: "Aktives Stück leeren",
      resetView: "Ansicht zurücksetzen",
      saving: "Speichern…", saved: "Gespeichert", save: "Speichern",
      saveTitle: "3D-Entwurf speichern", saveOverTitle: "Über Kapazität — entferne Voxel zum Speichern",
      publishTitle: "Die Veröffentlichung erfolgt im Canvas — diese gespeicherte 3D-Szene wird automatisch einbezogen",
      publishLink: "Im Canvas veröffentlichen →",
      reload: "Neu laden",
      color: "Farbe", customColorTitle: "Eigene Farbe",
      workArts: "Werke", newBase: "+ Neue Basis",
      budgetLabel: "Budget:", cellsUnit: "Zellen",
      noWorkArts: "Noch keine Werke.",
      activePiece: "Aktives Stück", rotate: "Drehen", rotationHint: "Setze die Drehung auf 0° zurück, um Voxel zu bearbeiten.",
      imageToVoxel: "Bild → Voxel", depth: "Tiefe", converting: "Konvertieren…", chooseImage: "Bild wählen…",
      conversionHelp: "Die Konvertierung hilft dir mit einer einfachen Extrusion zu starten. Du kannst das Ergebnis Voxel für Voxel verfeinern.",
      fallback: "3D-Bearbeitung benötigt WebGL, das dieses Gerät nicht starten konnte. Dein 3D-Entwurf ist sicher — probiere einen Desktop-Browser mit Hardwarebeschleunigung.",
      defineTitle: "Basis definieren — auf dem Raster ziehen",
      defineBody: "Ziehe ein Rechteck auf dem Boden, um dein Stück zu dimensionieren, und lass dann los, um es zu erstellen.",
      sizeLabel: "Größe", tooBig: "· zu groß",
      noCapacityTitle: "Keine freie 3D-Kapazität",
      noCapacityBody: "Du kannst auf diesem Territorium noch keine Blöcke platzieren. Das kostenlose 3D-Geschenk (10.000+ Voxel) wird nur dem Wallet gewährt, das eine Parzelle im Primärverkauf gekauft hat und sie noch besitzt. Parzellen, die beansprucht/geprägt oder gebraucht gekauft wurden, erhalten keines.",
      hintNewBase: "Klicke auf „+ Neue Basis“ und ziehe dann auf dem Raster, um dein Stück zu dimensionieren.",
      howToBuild: "So baust du",
      step1: "Klicke + Neue Basis, dann ziehe auf dem Raster, um das Stück zu dimensionieren",
      step2: "Linksklick auf den Boden / die Fläche eines Blocks, um Blöcke zu platzieren",
      step3: "Rechtsklick auf einen Block, um ihn zu entfernen",
      mouse: "Maus", showControls: "Steuerung & Bauanleitung anzeigen", hide: "Ausblenden",
      leftClick: "Linksklick", rightClick: "Rechtsklick", ctrlLeft: "Strg + links", ctrlRight: "Strg + rechts", scroll: "Scrollen",
      drawBase: "Basis zeichnen", placeBlock: "Block platzieren", removeBlock: "Block entfernen", orbit: "Um den Klick kreisen", pan: "Ansicht verschieben", zoomInOut: "Rein- / rauszoomen",
      capacity3d: "3D-Kapazität", overCapacity: "Über Kapazität",
    },
    templates: {
      title: "Canvas-Vorlagen",
      curatedStarts: "6 kuratierte Startpunkte",
      close: "Vorlagen schließen",
      apply: "Vorlage anwenden",
      previewAria: "Layout-Vorschau von {name}",
      replaceTitle: "Aktuellen Entwurf ersetzen?",
      replaceBody: "Wenn du {name} anwendest, wird der Inhalt deines aktuellen Entwurfs ersetzt ({count} {unit}). Dein veröffentlichtes Territorium bleibt unberührt, bis du speicherst und veröffentlichst. Dies kann nur mit Rückgängig widerrufen werden.",
      elementOne: "Element",
      elementOther: "Elemente",
      cancel: "Abbrechen",
      replaceDraft: "Entwurf ersetzen",
      catalog: {
        creator: { name: "Creator / Personal Brand", useCase: "Persönliche Identität", tagline: "Eine kühne, zentrierte Identität — Name, Rolle, Bio, Social-Links und ein einzelner Call to Action.", tag0: "Identität", tag1: "Bio", tag2: "Social" },
        retail: { name: "Einzelhandel / Schaufenster", useCase: "Kleine Marke & Shop", tagline: "Ein Marken-Header über einem rhythmischen Produktregal, mit einer klaren Shop-besuchen-Aktion.", tag0: "Produkte", tag1: "Regal", tag2: "Shop-Link" },
        gallery: { name: "Künstler / Galerie", useCase: "Werk zuerst", tagline: "Ein einziger dominanter Rahmen mit einer leisen Aussage — das Werk führt, Worte folgen.", tag0: "Werk", tag1: "Aussage", tag2: "Minimal" },
        music: { name: "Musik / Event", useCase: "Release & Live-Event", tagline: "Energiegeladener Titel, Datum und Ort sowie eine direkte Tickets- / Stream-Aktion.", tag0: "Event", tag1: "Datum", tag2: "Tickets" },
        product: { name: "Produkt / Tech-Launch", useCase: "Launch-Landing", tagline: "Eine moderne Launch-Seite — Überschrift, Begleitzeile, drei Feature-Blöcke und ein CTA.", tag0: "Launch", tag1: "Features", tag2: "CTA" },
        minimal: { name: "Minimaler Luxus", useCase: "High-End-Minimalismus", tagline: "Zurückhaltende Typografie und großzügiger Raum — ein Wort, eine Zeile, eine Aktion.", tag0: "Luxus", tag1: "Weißraum", tag2: "Zurückhaltung" },
      },
    },
    error: {
      title: "Der Canvas ist auf einen Fehler gestoßen",
      body: "Der Editor hat sich erholt, statt schwarz zu werden. Nicht gespeicherte Änderungen seit deinem letzten Speichern wurden nicht auf den Server geschrieben. Versuche zu verwerfen, um fortzufahren, oder lade den Editor für einen sauberen Zustand neu.",
      dismiss: "Verwerfen",
      reload: "Editor neu laden",
    },
    canvas: {
      invalid: "Ungültige Canvas-Route.",
      authRequired: "Melde dich mit deinem Wallet an, um diesen Canvas zu bearbeiten.",
      signIn: "Anmelden →",
      loading: "Canvas wird geladen…",
      empty: "Kein Canvas.",
      failedToLoad: "Laden fehlgeschlagen",
      back: "Zurück",
      close: "Schließen",
      cancel: "Abbrechen",
      exitConfirm: "Du hast nicht gespeicherte Änderungen. Ohne Speichern verlassen?",
      flash: {
        saved3d: "3D-Position gespeichert",
        territoryChanged3d: "Territorium geändert — lade den Editor neu",
        error3d: "3D: {code}",
        rotateOutside: "Die Drehung würde das Territorium verlassen",
      },
      save: {
        territoryChanged: "Territorium geändert — Editor neu laden",
      },
      toolbar: {
        territories: "Territorien",
        undo: "Rückgängig",
        redo: "Wiederholen",
        fit: "Territorium einpassen",
        templates: "Vorlagen",
        templatesTitle: "Mit einer Premium-Vorlage starten",
        templatesDisabledTitle: "Vorlagen benötigen ein eigenes Territorium",
        mediaLibrary: "Medienbibliothek",
        mediaLibraryTitle: "Medienbibliothek — hochladen & durchsuchen, ohne den Editor zu verlassen",
        artistProfile: "Künstlerprofil",
        artistProfileTitle: "Öffne dein Künstlerprofil",
        editor3d: "3D-Editor",
        editor3dTitle: "Öffne den 3D-Voxel-Editor für dieses Territorium",
        save: "Speichern",
        saving: "Speichern…",
        saveTitle: "Canvas speichern",
        saveOverTitle: "Kapazität überschritten — GP-Nutzung reduzieren, um zu speichern",
        freeze: "Einfrieren",
        freezeTitle: "Dieses Pixel-Studio-Werk einfrieren",
        freezeBlockedTitle: "Speichere den Canvas vor dem Einfrieren",
      },
      tools: {
        pixelArt: "Pixel Art",
        new: "NEU",
        text: "Text",
        interactive: "Interaktiv",
        media: "Medien",
        shapes: "Formen",
      },
      pixelDraw: {
        banner: "Zeichne ein Rechteck auf deinem Territorium",
      },
      pixelSize: {
        title: "Neue Pixel Art",
        body: "Wähle eine Canvas-Größe — 1 Zelle = 1 Parzelle. Leere Zellen bleiben transparent.",
        custom: "Benutzerdefiniert — auf dem Territorium zeichnen",
      },
      mobileReadonly: "Auf diesem Gerät nur Lesen / Ansehen. Bearbeiten erfordert einen größeren Bildschirm.",
      gp: {
        used: "Genutzt",
        available: "Verfügbar {n} GP",
        overCapacity: "Kapazität überschritten",
      },
      status: {
        saved: "Gespeichert",
        unsavedChanges: "Nicht gespeicherte Änderungen",
        saving: "Speichern…",
        error: "Fehler",
        showError: "Vollständigen Fehler anzeigen",
      },
      inspector: {
        territoryTiers: "Territorium-Stufen",
        globalStyle: "Globaler Stil",
        background: "Hintergrund",
        bgColor: "Hintergrundfarbe",
        perimeter: "Umrandung",
        perimeterGlow: "Umrandungs-Glühen",
        opacity: "Deckkraft {v}%",
        glow: "Glühen",
        glowColor: "Glüh-Farbe",
        text: "Text",
        label: "Beschriftung",
        subtitleOptional: "Untertitel (optional)",
        urlHttps: "URL (https)",
        previewOpen: "Vorschau / Öffnen ↗",
        fill: "Füllung",
        lineColor: "Linienfarbe",
        fit: "Anpassung",
        pixelArt: "Pixel Art",
        editPixels: "Pixel bearbeiten",
        title: "Titel",
        bgPreview: "Hintergrund-Vorschau",
        changeImage: "Bild ändern",
        addImage: "+ Bild hinzufügen",
        selectedGp: "GP {used} / {max} max",
      },
      controls: {
        preset: "Preset",
        layout: "Layout",
        direction: "Richtung",
        columns: "Spalten {v}",
        align: "Ausrichtung",
        gap: "Abstand {v}",
        iconSize: "Icon-Größe {v}",
        labelOptional: "Beschriftung (optional)",
        labelColor: "Beschriftungsfarbe",
        brandColors: "Markenfarben",
        iconColor: "Icon-Farbe",
        backgroundChip: "Hintergrund-Chip",
        bgColor: "Hintergrundfarbe",
        border: "Rahmen",
        borderColor: "Rahmenfarbe",
        radius: "Radius",
        padding: "Innenabstand {v}",
        hover: "Hover",
        font: "Schriftart",
        color: "Farbe",
        textSize: "Textgröße {v}",
        style: "Stil",
        subtitleColor: "Untertitelfarbe",
        underline: "Beschriftung unterstreichen",
        icon: "Icon",
      },
      social: {
        links: "Links ({n}/5)",
        removeLink: "Link entfernen",
        addLink: "+ Link hinzufügen",
        showLabels: "Beschriftungen anzeigen",
        labelFont: "Beschriftungs-Schriftart",
        labelSize: "Beschriftungsgröße {v}",
      },
      contacts: {
        heading: "Kontakte ({n}/10)",
        removeContact: "Kontakt entfernen",
        addContact: "+ Kontakt hinzufügen",
        show: "Anzeigen",
        value: "Wert",
        dataColor: "Datenfarbe",
        kind: { EMAIL: "E-Mail", PHONE: "Telefon", WHATSAPP: "WhatsApp", WEBSITE: "Website", MAP: "Adresse" },
        placeholder: { EMAIL: "name@beispiel.de", PHONE: "+49 30 0001234", WHATSAPP: "+49 30 0001234", WEBSITE: "https://beispiel.de", MAP: "Hauptstr. 1, Stadt" },
      },
      layers: {
        title: "Ebenen",
        empty: "Noch keine Module.",
        front: "Nach vorne",
        forward: "Vorwärts",
        backward: "Rückwärts",
        back: "Nach hinten",
        hide: "Ausblenden",
        lock: "Sperren",
      },
      mediaPanel: {
        title: "Medienbibliothek",
        working: "Läuft…",
        upload: "Hochladen",
        hint: "Bild 10 · GIF 20 (10s) · PDF 25 · Video 250 MiB · Bibliothek 2 GiB. Uploads erscheinen sofort in den Medien-Auswahlfenstern.",
        loading: "Bibliothek wird geladen…",
        empty: "Noch keine Medien. Lade ein Bild, GIF, PDF oder Video hoch, um deine Bibliothek zu starten.",
        loadMore: "Mehr laden",
        deleteAria: "Asset löschen",
      },
      mediaPicker: {
        choose: "{kind} aus der Medienbibliothek wählen",
        empty: "Keine {kind}-Assets. Lade zuerst in der Dashboard-Medienbibliothek hoch.",
      },
      mediaKind: { image: "Bild", gif: "GIF", video: "Video", pdf: "PDF" },
      errorModal: {
        saveFailed: "Speichern fehlgeschlagen",
        gotIt: "Verstanden",
      },
      tier: { STANDARD: "Standard", PREMIUM: "Premium", VIP_CORE: "VIP Core", RESERVE: "Reserve", GRID_ZERO: "GRID ZERO" },
      enum: {
        module: { TITLE: "Titel", TAGLINE: "Slogan", DESCRIPTION: "Beschreibung", LINK: "Link", SOCIAL: "Social", CONTACTS: "Kontakte", IMAGE: "Bild", GIF: "GIF", VIDEO: "Video", PDF: "PDF", PIXEL_ART: "Pixel Art", SHAPE: "Form" },
        shape: { RECTANGLE: "Rechteck", ROUNDED_RECTANGLE: "Abgerundetes Rechteck", ELLIPSE: "Ellipse", LINE: "Linie" },
        bgMode: { NEUTRAL: "Neutral", SOLID_COLOR: "Volltonfarbe" },
        glow: { OFF: "Aus", LOW: "Niedrig", MEDIUM: "Mittel", HIGH: "Hoch" },
        direction: { HORIZONTAL: "Horizontal", VERTICAL: "Vertikal", GRID: "Raster" },
        align: { START: "Anfang", CENTER: "Mitte", END: "Ende" },
        textAlign: { LEFT: "Links", CENTER: "Mitte", RIGHT: "Rechts", JUSTIFY: "Blocksatz" },
        radius: { SQUARE: "Eckig", SLIGHT: "Leicht", ROUNDED: "Abgerundet", PILL: "Pille" },
        hover: { NONE: "Keiner", LIFT: "Anheben", GLOW: "Glühen", SCALE: "Skalieren" },
        fit: { COVER: "Füllen", CONTAIN: "Einpassen" },
        contactsDisplay: { ICON: "Icon", ICON_LABEL: "Icon + Beschriftung", ICON_DATA: "Icon + Daten", BUTTON: "Schaltfläche" },
        linkIcon: { NONE: "Keines", ARROW: "Pfeil", FAVICON: "Favicon" },
        socialPreset: { ICONS_ONLY: "Nur Icons", MINIMAL: "Minimal", BUTTONS: "Schaltflächen", CARDS: "Karten" },
        contactsPreset: { ICONS_ONLY: "Nur Icons", BUSINESS: "Business", MINIMAL: "Minimal" },
        linkPreset: { TEXT: "Text", BUTTON: "Schaltfläche", OUTLINE: "Umriss", CARD: "Karte" },
      },
    },
  },
};

export default de;
